{
  "accessRights": {
    "allStudentsHaveAccess": "relevant for {className} ({studentCount})",
    "allSubjects": "All subjects",
    "canCreateCompetences": "Create competence entries",
    "canManageAccessRights": "Manage rights and access",
    "canManageAccessRightsTooltip": "The teacher can add other colleagues to the class and manage their access rights.",
    "canManageArchiveRights": "Manage archive rights",
    "canManageCompetences": "Manage competences",
    "canManageCompetencesTooltip": "The teacher can flexibly create, edit, and delete subjects and their competences.",
    "canManagePerformanceAssessments": "Manage performance assessments",
    "canManagePerformanceAssessmentsTooltip": "The teacher can create, edit, and remove performance assessments at any time.",
    "canManageStudents": "Manage students",
    "canManageStudentsTooltip": "The teacher can add, edit, and remove students from the class at any time.",
    "currentStaffDescription": "The following team members have access:",
    "currentStudentsDescription": "This competence is relevant for the following students:",
    "hasAccessDouble": "{name1} and {name2} have access",
    "hasAccessMultiple": "{name1}, {name2}, and { count } other have access | { name1}, {name2}, and { count } others have access",
    "hasAccessSingle": "{name1} has access",
    "hasAccessTriple": "{name1}, {name2} and {name3} have access",
    "hasArchiveReadRights": "Archive read rights",
    "hasNoPermissions": "No additional permissions",
    "pleaseSelect": "Please select",
    "proAccessRightsTooltip": "With a Digidoo subscription, you decide who can manage students, competences, performance assessments, and access rights in each class.",
    "removeButton": "Remove",
    "removeDescription": "Are you sure you want to remove this teacher from the class?",
    "removeTitle": "Remove teacher",
    "selectSpecific": "Only the following",
    "someStudentsHaveAccess": "relevant for {studentCount}",
    "splitStudentsEntry": "Show individual students"
  },
  "administrationSetup": {
    "close": "Close",
    "competences": {
      "body": "Adjust the competence grid for your school.",
      "customize": {
        "description": "Build your grid individually.",
        "title": "Customize competence grid"
      },
      "template": {
        "description": "Start with a related template and adapt it to your school.",
        "title": "Choose competence template"
      },
      "title": "Adjust competences"
    },
    "initial": {
      "classes": {
        "description": "Create more classes and start documenting.",
        "title": "Create classes"
      },
      "competences": {
        "description": "Adjust subjects and competences.",
        "title": "Adjust competences"
      },
      "recommended": "(recommended)",
      "students": {
        "description": "Create students and assign them to your classes.",
        "title": "Manage students"
      },
      "team": {
        "description": "Bring your colleagues on board and document progress together.",
        "title": "Invite team"
      },
      "title": "Ready for your own start?"
    }
  },
  "apiTokens": {
    "generate": "Generate",
    "title": "API Tokens",
    "token": "Token"
  },
  "auth": {
    "PasswordResetWidget": {
      "successText": "You can now log in with your new password.",
      "successTitle": "Done!",
      "toLogin": "Go to login"
    },
    "action": {
      "login": "Login"
    },
    "deletedUser": "Deleted teacher",
    "emailChange": {
      "failed": "Email change failed.",
      "goToLogin": "Go to login",
      "invalidLink": "Invalid link",
      "loading": "Confirming your new email address...",
      "loginRequired": "Please log in with your old email address first to confirm your new email address.",
      "successText": "Your email address has been successfully changed to {email}. You can now log in with your new address.",
      "successTitle": "Email address changed successfully",
      "title": "Confirm email address"
    },
    "finish-registration": {
      "checkingCode": "Checking invitation link...",
      "finish": "Complete registration",
      "invalidCode": "Sorry, this invitation link is not valid (anymore)!",
      "title": "Please set your password."
    },
    "footer": {
      "contactMail": "mailto:support{'@'}digidoo.com?subject=Contact%20request",
      "dataProtection": "Privacy",
      "legalNotice": "Legal notice",
      "terms": "Terms",
      "version": "Beta version"
    },
    "invite": {
      "alreadyLoggedIn": "You are already logged in with this account. How do you want to continue?",
      "declineInvitation": "Do not accept invitation",
      "existingUserLoginToAccept": "A Digidoo account already exists for this email address. Please log in to accept the invitation.",
      "loginExistingAccount": "Log in with existing account",
      "loginWithDifferentAccount": "Log in with another account",
      "title": "{invitedBy} has invited you to join the team \"{teamName}\".",
      "titleCode": "You have been invited to join the team \"{teamName}\"."
    },
    "login": {
      "appleLoginAction": "Continue with Apple",
      "bildungsportalLoginAction": "Continue with Education portal",
      "errorDeactivated": "This account has been deactivated. Please contact support.",
      "googleLoginAction": "Continue with Google",
      "invitationLoginHint": "Please log in with {email} to accept the invitation.",
      "loginAction": "Login",
      "loginEmailOtpHint": "Your code is valid for 15 minutes.",
      "loginEmailOtpTitle": "Please enter the code we sent to <span class='font-medium'>{email}</span>",
      "loginTotpTitle": "Please enter the code shown in your authenticator app.",
      "lostPassword": "Lost password?",
      "newToDigidoo": "New to digidoo?",
      "or": "or",
      "password": "Your password",
      "register": "Register",
      "resendEmailOtp": "Resend email",
      "resendEmailSuccess": "Your new code has been sent to you by email",
      "title": "Login",
      "userIdentifier": "Your username"
    },
    "password": {
      "newPassword": "New password",
      "newPasswordRepeat": "New password (repeat)"
    },
    "password-reset": {
      "actionButtonLabel": "Set password",
      "checkingCode": "Checking reset code...",
      "invalidCode": "Sorry, this reset code is not valid (anymore)",
      "title": "Change password"
    },
    "register": {
      "alreadyRegistered": "Already registered?",
      "conditionsConsequence": "I agree to the {terms} and the {policy}.",
      "email": "Your email adress",
      "emailPlaceholder": "name{'@'}domain.com",
      "enterCodeDescription": "To join an existing school, click your invitation link or enter your one-time access code.",
      "enterCodeTitle": "Join an existing school",
      "fullName": "Your name (optional)",
      "invitationEmailMismatchError": "This invitation is tied to a different email address. Please contact your school.",
      "invitationExistingUserError": "A Digidoo account already exists for this email address. Please log in to accept the invitation.",
      "invitationLockedEmailHint": "Different email address? Please contact your school for a new invitation.",
      "joinExistingSchoolText": "To join an existing school, click your invitation link or enter your one-time access code.",
      "joinNewsletter": "I'd like to receive updates about Digidoo.",
      "joinSchool": "Join",
      "joinSchoolDescription": "I received an invitation to join a team.",
      "login": "Login",
      "loginToAcceptInvitation": "Go to login",
      "onboardNewSchool": "Create",
      "onboardNewSchoolDescription": "I want to create a new school, private institution, etc.",
      "onboardingOverviewJoinTeam": "Join a team",
      "onboardingOverviewJoinTeamDescription": "With code or invitation",
      "onboardingOverviewStartSchool": "Get started with Digidoo",
      "onboardingOverviewStartSchoolDescription": "On your own or as a team",
      "privacy": "privacy policy",
      "registerAction": "Register",
      "success": {
        "back": "Back to login",
        "text": "You'll receive an email at {email} shortly to complete your registration.",
        "title": "Almost there!"
      },
      "terms": "terms and conditions incl. data processing agreement",
      "title": "Register new account"
    },
    "reset-password": {
      "email": "Email address",
      "emailSent": "We've sent a link to reset your password to the email address you provided, if it's registered in our system.",
      "resetAction": "Reset",
      "title": "Reset password",
      "to-login": "Go to login"
    },
    "sso": {
      "backToLogin": "Back to login",
      "errorText": "The login could not be completed. Please try again.",
      "errorTitle": "Login failed",
      "loadingText": "One moment please.",
      "loadingTitle": "Completing login",
      "startLoadingText": "You are being redirected to the SSO provider.",
      "startLoadingTitle": "Starting login"
    }
  },
  "authProviders": {
    "columns": {
      "config": "Config",
      "default": "Default",
      "enabled": "Enabled",
      "id": "ID",
      "name": "Name",
      "type": "Type"
    },
    "create": "Create auth provider",
    "dialog": {
      "configJsonError": "Config must be valid JSON.",
      "configObjectError": "Config must be a JSON object.",
      "createTitle": "Create auth provider",
      "editTitle": "Edit auth provider"
    },
    "title": "SSO"
  },
  "billing": {
    "active": {
      "body": "Your Digidoo subscription is active. You can use all features without restrictions – from competence documentation and reports to learning analysis.",
      "note": "🥰 Thank you for using Digidoo!",
      "title": "Your Digidoo {product} subscription is active."
    },
    "availablePlans": "More subscriptions for you and your team",
    "banner": {
      "actions": {
        "contactLead": "Contact school management",
        "manage": "Manage subscription",
        "reactivate": "Reactivate subscription",
        "renew": "Renew subscription",
        "subscribe": "Subscribe",
        "trialUpsell": "Get {percent}% off",
        "trialUpsellFallback": "Get discount"
      },
      "email": {
        "body": "Hi {firstNameReceiver} 👋,\n\ncould you please upgrade the Digidoo subscription so I’ll keep full access to all features?\n\nThanks a lot! :)\n\nBest regards\n{firstNameSender}",
        "subject": "Digidoo trial: upgrade request 😊"
      },
      "subEnded": {
        "note": "You can still view your existing content, but not create new content.",
        "title": "Your Digidoo {product} subscription has expired."
      },
      "subEnding": {
        "title": "Your Digidoo {product} subscription ends in {days} days."
      },
      "trialEnded": {
        "note": "You can still view your existing content, but not create new content.",
        "title": "Your Digidoo {product} trial has expired."
      },
      "trialEnding": {
        "headline": "You're currently using Digidoo with all features 🌸",
        "subtitle": "You have {count} day left in your trial. | You have {count} days left in your trial.",
        "title": "Your Digidoo {product} trial ends in {days} days."
      },
      "trialInfo": {
        "actions": {
          "class": "class",
          "team": "team"
        },
        "afterTrial": "After that, you can continue using Digidoo for free.",
        "cta": {
          "bothEnd": ".",
          "bothMiddle": "or invite your",
          "bothStart": "Start now with your own",
          "classOnlyEnd": ".",
          "classOnlyStart": "Start now with your own",
          "teamOnlyEnd": ".",
          "teamOnlyStart": "Invite your"
        },
        "features": {
          "classAnalysis": "analysis & class overview",
          "individualWeighting": "individual grade weighting",
          "sharedReports": "shared reports",
          "teamCollaboration": "team collaboration"
        },
        "includedTitle": "Included:",
        "trialActiveUntil": "Trial active until:"
      },
      "trialUpsell": {
        "headline": "You are currently using Digidoo with all features 🌸"
      }
    },
    "basis": {
      "body": "Choose a subscription to unlock all features – including the competence flower, reports, and targeted learning analysis.",
      "note": "🤩 Get Digidoo from just <strong>{price} per student</strong> per year!",
      "title": "You're using Digidoo Basic."
    },
    "buttons": {
      "addPaymentMethod": "Add payment method",
      "changeSeats": "Change quantity",
      "chooseSubscription": "Choose subscription",
      "comparePlans": "Compare plans",
      "contact": "Contact us",
      "invoices": "View invoices",
      "manage": "Manage subscription",
      "openInvoice": "View invoice",
      "openPriceCalculator": "Open price calculator",
      "switch": "Switch",
      "upgrade": "Upgrade"
    },
    "checkoutProductDialog": {
      "cancelScheduledChangeHint": "Continuing cancels the scheduled plan change.",
      "currentSelectionHint": "This is your current subscription.",
      "description": "From individuals and small teams to entire schools – with our subscription plans, Digidoo adapts perfectly to your needs.",
      "subtitleCompact": "This feature requires an active subscription.",
      "email": {
        "body": "Hello,\n\ncould you please manage or activate the Digidoo subscription? Thanks!\n",
        "subject": "Digidoo: Request for subscription approval/renewal"
      },
      "eyebrow": "Billing",
      "features": {
        "collaboration": "Work efficiently as a team",
        "competenceDocumentation": "Document learning progress clearly",
        "reports": "Create reports with one click",
        "statistics": "Analyze visually with the competence flower",
        "support": "Get support from us anytime"
      },
      "overview": {
        "additionalDescription": "With your Digidoo subscription, you also get…",
        "annualDiscount": "🎁 up to 50% cheaper with annual billing",
        "fallback": {
          "title": "Get your Digidoo subscription\nand use all features."
        },
        "features": {
          "customization": "School logo, images and much more",
          "development": "Competence & development progress",
          "gradeWeighting": "Grade calculation & weighting",
          "reports": "Reports",
          "reportsAndSupportMeasures": "Reports & support measures",
          "roles": "Roles & permissions",
          "supportMeasures": "Support measures"
        },
        "gradeWeighting": {
          "title": "Get your Digidoo subscription\nand use grade weighting."
        },
        "reports": {
          "title": "Get your Digidoo subscription\nand use reports."
        },
        "supportMeasures": {
          "title": "Get your Digidoo subscription\nand use support measures."
        }
      },
      "planSelectionAriaLabel": "Subscription plans",
      "studentQuestion": "How many students?",
      "subtitle": "and use all features without restrictions.",
      "teacherQuestion": "How many teachers?",
      "title": "Get your Digidoo subscription",
      "titleContinuation": "and use all features",
      "titleSecondLine": "without restrictions."
    },
    "chooseYourPlan": "Find your perfect Digidoo.",
    "currentPlan": "Active",
    "endTrialNow": "End trial",
    "feedbackDialog": {
      "missingFeatures": "I'm still missing some features",
      "preferFreeVersion": "All good, I'd rather keep using it for free for now",
      "secureDiscount": "Secure a {percent}% discount",
      "sendFeedback": "Send feedback",
      "textPlaceholder": "Any other feedback?",
      "title": "You're using the free version of Digidoo. Want to give us some feedback?",
      "tooExpensive": "The price doesn't work for me right now",
      "underUsed": "I haven't been able to try all the features yet"
    },
    "intervalToggle": {
      "ariaLabel": "Billing interval",
      "cheaper": "cheaper",
      "monthly": "Monthly billing",
      "monthlyShort": "Monthly",
      "withYearlyBilling": "with yearly billing",
      "yearly": "Yearly billing",
      "yearlyDiscountLabel": "up to {percent}% cheaper with yearly billing",
      "yearlySavingsLabel": "up to {percent}% cheaper",
      "yearlyShort": "Yearly"
    },
    "invoiceAddressSettings": {
      "description": "This address is used for future invoices.",
      "title": "Invoice address"
    },
    "invoicePayment": {
      "addressFutureOnlyHint": "Changes apply to future invoices. Already issued invoices can only be corrected by support.",
      "addressSubtitle": "This address is used for this invoice and future invoices.",
      "addressTitle": "Enter billing details",
      "confirmCreateInvoiceButton": "Start subscription & create invoice",
      "confirmCreateInvoiceDescription": "Please make sure the name and address match the institution or organization that will pay for this subscription. With this confirmation, you start the yearly Digidoo subscription and create a payable invoice with a 14-day payment term.",
      "confirmCreateInvoiceTitle": "Check invoice details",
      "createInvoice": "Create invoice",
      "eyebrow": "Billing",
      "fields": {
        "city": "City",
        "country": "Country",
        "line1": "Address",
        "name": "Name",
        "notes": "Notes (optional)",
        "notesPlaceholder": "Additional invoice details",
        "postalCode": "Postal code",
        "vatId": "VAT ID (optional)"
      },
      "invalidVatId": "Enter a valid VAT ID with country prefix, for example {example}.",
      "invoiceDescription": "Your school or organization pays the invoice amount by bank transfer.",
      "invoiceDueHint": "14-day payment term",
      "invoiceTitle": "Payment by bank transfer",
      "methodSubtitle": "You can pay online or create an invoice with a 14-day payment term.",
      "methodTitle": "How would you like to pay?",
      "onlineDescription": "Pay directly and securely with card, PayPal, Apple Pay, Google Pay & more.",
      "onlineTitle": "Online payment",
      "overdueNote": "Pay the open invoice to reactivate access.",
      "pendingNote": "Please keep the payment term in mind.",
      "requestOptionText": "My school or organization pays by bank transfer.",
      "reviewInvoiceAddressButton": "Review details",
      "secureStripe": "Securely via Stripe",
      "stripePrefix": "Payment is securely processed by",
      "stripeSuffix": ".",
      "successDescription": "You have 14 days\nto complete the payment.",
      "successThanks": "Until then, you can already use all features without restrictions.",
      "successTitle": "Your {product} subscription is ready 🎉"
    },
    "invoices": {
      "actions": {
        "download": "Download invoice",
        "open": "View invoice"
      },
      "columns": {
        "amount": "Amount",
        "date": "Date",
        "name": "Name",
        "product": "Subscription",
        "status": "Status"
      },
      "empty": "No invoices yet.",
      "fallbackDate": "-",
      "fallbackInvoiceTitle": "Invoice",
      "fallbackProduct": "Subscription",
      "fallbackQuantity": "-",
      "invoiceTitle": "Invoice {number}",
      "quantity": "{count} seats",
      "status": {
        "open": "Open",
        "paid": "Paid",
        "uncollectible": "Uncollectible",
        "unknown": "Unknown",
        "void": "Void"
      }
    },
    "offers": {
      "acceptHint": "After acceptance, you have 14 days to complete the payment. All features are available immediately.",
      "acceptOffer": "Accept offer",
      "acceptTitle": "Review offer",
      "actions": {
        "adjust": "Adjust offer",
        "delete": "Delete offer",
        "download": "Download offer"
      },
      "addressTitle": "Enter offer details",
      "amount": "Amount:",
      "cardStatus": "Offer created",
      "createOffer": "Create offer",
      "createTitle": "Create offer",
      "deleteConfirmDescription": "The open offer will be deleted and can no longer be accepted.",
      "deleteConfirmTitle": "Delete offer?",
      "deleteOffer": "Delete offer",
      "editAddressLink": "edit",
      "emptyDocuments": "No invoices or offers yet.",
      "exclVat": "excl. VAT",
      "fallbackOfferTitle": "Offer",
      "invoiceAcceptedDescription": "The subscription is active. Please pay the invoice within 14 days.",
      "invoiceAcceptedTitle": "Invoice created.",
      "monthlyUnavailableHint": "Offers cannot be created for monthly subscriptions.",
      "offer": "Offer",
      "offerTitle": "Offer {number}",
      "offerValidUntil": "Offer valid until:",
      "onlinePayment": "Online payment",
      "pdfFilePrefix": "offer",
      "reviewProductDescriptionFallback": "Ideal for your Digidoo usage.",
      "reviewProductDescriptionSchool": "Ideal for whole schools and teams.",
      "reviewProductDescriptionTeam": "Ideal for individuals and small teams.",
      "reviewProductName": "Digidoo {product}",
      "status": {
        "accepted": "Accepted",
        "deleted": "Deleted",
        "expired": "Expired",
        "pending": "Open",
        "replaced": "Replaced"
      },
      "successDescription": "Your offer has been created and is valid for 30 days.",
      "successDetails": "We're looking forward to having you!",
      "successTitle": "Done 🎉",
      "vatLine": "VAT ID: {vatId}",
      "viewOffer": "View offer"
    },
    "perYear": "per year",
    "planSwitchConfirm": {
      "cancelScheduledChangeConfirmButton": "Cancel change",
      "cancelScheduledChangeDescription": "A change to your subscription is scheduled for the end of the current period. If you continue, it will be cancelled and your current subscription {current} stays unchanged.",
      "cancelScheduledChangeSuccess": "The scheduled subscription change has been cancelled.",
      "cancelScheduledChangeTitle": "Cancel scheduled change?",
      "confirmButton": "Confirm change",
      "description": "Current: {current}\nNew: {target}\n\n{effect}",
      "immediateEffect": "We will switch your subscription right away so you can use the new plan immediately.",
      "immediateWithAmountEffect": "We will switch your subscription right away so you can use the new plan immediately. The estimated amount due now is {amount}.",
      "immediateWithInvoiceEffect": "We will switch your subscription right away so you can use the new plan immediately. If the change creates an open amount, you will find it in your billing area afterwards.",
      "immediateWithoutPaymentEffect": "We will switch your subscription right away so you can use the new plan immediately. No immediate payment is expected for this change.",
      "nextPeriod": "the next billing period",
      "periodEndEffect": "Your current plan stays active until {date}. The new plan starts after that.",
      "quantity": "{quantity} {unit}",
      "title": "Confirm subscription change",
      "unknownInterval": "Billing interval",
      "unknownPlan": "Current plan"
    },
    "priceCalculatorDialog": {
      "selection": {
        "useAsSchool": "I want to use Digidoo <strong>as a school or large team</strong>",
        "useForMe": "I want to use Digidoo <strong>on my own</strong>",
        "useTogether": "I want to use Digidoo <strong>on my own or in a team</strong>"
      },
      "title": "Price calculator",
      "yourMonthlyCosts": "Your monthly costs",
      "yourYearlyCosts": "Your yearly costs"
    },
    "pricesExclVat": "All prices exclude VAT.",
    "products": {
      "basis": {
        "currentlyActive": "currently active",
        "description": "<b>You're on the free version of Digidoo.</b> You can still view your existing content and create new entries. Analyzing with the competence flower and creating reports require an active subscription. Start a subscription now to get full access to all Digidoo features again.",
        "priceLabel": "{price}",
        "shortDescription": "Document learning progress",
        "shortTitle": "Basic",
        "title": "Digidoo Basic"
      },
      "checkoutDescriptionBillingPrefix": "Billed by ",
      "freeTrial": {
        "description": "Enjoy all of Digidoo's features. Have fun!",
        "title": "Trial"
      },
      "pro": {
        "description": "For individuals",
        "highlight": "🚀 Perfect to get started",
        "pricing": "<b>{price}</b> per year",
        "pricingCalculatorDescription": "For individuals",
        "pricingYearlyLine": "{price} for one year",
        "title": "One"
      },
      "school": {
        "checkoutDescriptionUnit": "students",
        "checkoutMonthlyDescriptionPrefix": "For whole schools and teams.",
        "checkoutMonthlyLine": "{price} per student and month",
        "checkoutYearlyDescriptionPrefix": "For whole schools and teams.",
        "checkoutYearlyLine": "From {price} per student and year",
        "description": "For whole schools & teams",
        "highlight": "🥳 Work as a team",
        "pricing": "<b>from {perSeat}</b> per student and year",
        "pricingCalculatorDescription": "from {price} per student and year",
        "pricingYearlyLine": "annual tiered pricing",
        "title": "Team"
      },
      "team": {
        "checkoutDescriptionUnit": "teachers",
        "checkoutMonthlyDescriptionPrefix": "For individuals and small teams.",
        "checkoutMonthlyLine": "{price} per teacher and month",
        "checkoutYearlyDescriptionPrefix": "For individuals and small teams.",
        "checkoutYearlyLine": "{price} per teacher and year",
        "description": "For individuals & small groups",
        "highlight": "🚀 Perfect to get started",
        "pricing": "<b>{perSeat}</b> for each teacher and year",
        "pricingCalculatorDescription": "{price} per teacher and year",
        "pricingYearlyLine": "{price} for one year",
        "title": "Flex"
      },
      "discount": {
        "secureOffer": "🎁 Secure a {percent}% discount"
      },
      "trialDiscount": {
        "alwaysCheap": "Always affordable",
        "badge": "{percent}% discount",
        "validDuringTrial": "🎁 {percent}% discount during the trial"
      },
      "units": {
        "forOneYear": "{price} for one year",
        "monthlyCancelable": "cancel monthly",
        "perMonth": "per month",
        "perStudentPerMonth": "per student and month",
        "perStudentPerYear": "per student and year",
        "perTeacherPerMonth": "per teacher and month"
      },
      "yearlyOnly": "Yearly only"
    },
    "provider": {
      "checkoutSecurelyProcessedBy": "Payment is securely processed by",
      "handled": ".",
      "securelyProcessedBy": "Payment in Digidoo is securely processed by"
    },
    "seatTypes": {
      "students": "Students",
      "teamMembers": "Team members"
    },
    "statusCard": {
      "amountDue": "Amount due",
      "body": {
        "active": "<span class='font-semibold'>Your subscription is active.</span> You can use all features without restrictions – from competence documentation and reports to analyzing learning progress with the competence flower.",
        "invoiceDue": "<span class='font-semibold'>Your subscription is active and the invoice has been created.</span> Please pay within the payment term to keep access uninterrupted.",
        "invoiceOverdue": "<span class='font-semibold'>Your invoice is overdue.</span> Subscription features are paused until the open invoice has been paid.",
        "subscriptionEndsIn": "<span class='font-semibold'>Your subscription ends in {days} days.</span> After that, you can still view your content but won't be able to create new entries or reports. Renew now to keep full access.",
        "subscriptionHasEnded": "<span class='font-semibold'>Your subscription has expired.</span> You can still view your existing content but can't create new entries or reports. Start a subscription now to get full access to all Digidoo features again.",
        "trialEndsIn": "<span class='font-semibold'>Your {trialDays}-day trial is ending soon.</span> After that, you can still view your content but won't be able to create new entries or reports. Secure full access to all features now – including the competence flower, reports, and targeted learning analysis.",
        "trialHasEnded": "<span class='font-semibold'>Your trial has expired.</span> You can still view your existing content and create new entries. Analyzing with the competence flower and creating reports require an active subscription. Start a subscription now to get full access to all Digidoo features again.",
        "trialing": "<span class='font-semibold'>You're currently in your Digidoo trial ({days} days left).</span> After that, you can still view your content and create new entries. Analyzing with the competence flower and creating reports require an active subscription. Start a subscription now to keep using all Digidoo features without restrictions after the trial."
      },
      "cta": {
        "priceHint": "🤩 Get Digidoo from <strong>{price} per student</strong> per year!"
      },
      "exclVat": "excl. VAT",
      "invoiceDueDate": "Payment due",
      "nextBilling": "Next billing",
      "scheduledChange": "Scheduled plan change",
      "seatUsageBar": {
        "barText": "You're currently using <b>{used} of {total} seats</b>"
      },
      "status": {
        "active": "Your subscription is active",
        "invoiceDueIn": "Invoice due in {days} days",
        "invoiceOverdue": "Invoice overdue",
        "subscriptionEndsIn": "Your subscription ends in {days} days",
        "subscriptionHasEnded": "Your subscription has expired",
        "trialEndsIn": "Your trial ends in {days} days",
        "trialHasEnded": "Your trial has expired"
      }
    },
    "subEnded": {
      "body": "You can still view all your content but can't create new entries or reports. Reactivate your subscription to get access to all features again.",
      "note": "🤩 From <b>{price} per student</b> per year.",
      "reactivate": "Reactivate subscription",
      "title": "Your Digidoo {product} subscription has expired."
    },
    "subEnding": {
      "body": "After that, you can still view your content but won't be able to create new entries or reports. Renew now to keep full access.",
      "note": "🥰 Thank you for using Digidoo!",
      "renew": "Renew subscription",
      "title": "Your Digidoo {product} subscription ends in {days} days."
    },
    "subscription": {
      "state": "Subscription status",
      "status": {
        "active": "Active",
        "cancelScheduled": "Cancelled",
        "canceled": "Ended",
        "incomplete": "Incomplete",
        "incomplete_expired": "Expired",
        "past_due": "Payment overdue",
        "paused": "Paused",
        "subscriptionOver": "Subscription",
        "trialEnded": "Trial",
        "trialing": "Trial",
        "unpaid": "Unpaid"
      },
      "title": "Subscription"
    },
    "successDialog": {
      "acquisitionSource": {
        "description": "This helps us improve Digidoo more deliberately.",
        "otherPlaceholder": "If you selected other: where exactly did you hear about Digidoo?",
        "subtitle": "One quick question before you get started."
      },
      "description": "Thanks for your support. Together, we make school simpler and more modern. Share your ideas with us anytime.",
      "subtitle": "You can now use all features without restrictions. 🎉",
      "title": "Your Digidoo {product} subscription is ready."
    },
    "syncBillingCustomer": "Sync billing customer",
    "tabs": {
      "invoices": "Invoices & offers",
      "subscription": "Subscription"
    },
    "tipBilling": "Here you can keep track of your Digidoo subscription. You can view your current subscription status, access invoices, switch plans, or manage your subscription whenever you need to.",
    "trialEnded": {
      "body": "You can still view your existing content, but you can't create new entries or reports. Start a subscription now to get full access again.",
      "note": "😊 Thanks for trying it out!",
      "subscribe": "Subscribe",
      "title": "Your Digidoo {product} trial has expired."
    },
    "trialEnding": {
      "body": "After that, you can still view your content, but you won't be able to create new entries or reports. Secure full access to all features now – including the competence flower, reports, and targeted learning analysis.",
      "note": "🤩 Get Digidoo from as little as <strong>{price} per student</strong> per year!",
      "title": "Your Digidoo {product} trial ends in {days} days."
    },
    "trialExpiredDialog": {
      "comparePlansLink": "compare the plans",
      "downgradeToFreeVersion": "Continue with the free version",
      "downgradeToFreeVersionShort": "Continue for free",
      "firstEntryDone": {
        "description": "You can {freeUse} to document learning progress. Digidoo can take even more work off your plate. Learn more and {comparePlans}.",
        "title": "You've been actively using Digidoo 🌸"
      },
      "firstEntryPending": {
        "description": "You can {freeUse} to document learning progress. Digidoo can take even more work off your plate. Learn more and {comparePlans}.",
        "title": "Get time back for what really matters 🌸"
      },
      "freeUseHighlight": "keep using Digidoo for free"
    },
    "trialExtensionDialog": {
      "accept": "Keep testing for 7 more days",
      "decline": "No thanks",
      "description": "School life is busy, and sometimes you just need a few more days to try out Digidoo at your own pace. {highlight} – with all features, no commitment.",
      "descriptionHighlight": "We're extending your trial by 7 days, one time only",
      "successToast": "Your trial has been extended by 7 days.",
      "title": "More time to explore"
    },
    "trialUpsellDialog": {
      "discount": "{percent}% discount",
      "discountFallback": "a discount",
      "keepTestingButton": "Keep testing",
      "keepTestingText": "You still have {trialDays} days to get to know Digidoo at your own pace.",
      "keepTestingTitle": "Not sure yet?",
      "subtitle": "Document together as a team and create reports at the click of a button.",
      "title": "Save {discount} now!"
    }
  },
  "chartDateFilter": {
    "all": "Overall",
    "apply": "Apply",
    "cancel": "Cancel",
    "currentMonth": "Current Month",
    "currentYear": "Current Year",
    "last12Months": "Last 12 Months",
    "last30Days": "Last 30 Days",
    "last3Months": "Last 3 Months",
    "last6Months": "Last 6 Months",
    "lastMonth": "Last Month",
    "lastYear": "Last Year"
  },
  "classSelectorWidget": {
    "classListEntry": "Class { className }",
    "newClass": "New class",
    "title": "Class selection"
  },
  "classSetup": {
    "schoolSubjects": "Select subjects",
    "title": "Create class"
  },
  "classTeam": {
    "addMember": "Add",
    "allCompetences": "All competences",
    "emptyStateDescription": "Add the first team member now.",
    "emptyStateTitle": "No class team yet",
    "tip": "Here you can see all teachers who teach in your class <b>{currentClass}</b>. Permissions and subject access can be viewed here and can only be changed by admins. Depending on your own permissions, you can add more teachers to the class."
  },
  "myArchive": {
    "title": "My archive",
    "scopeHint": "You only see classes and groups you have access to.",
    "summary": "{classes} & {groups}",
    "manageSchoolYears": "Manage school years",
    "selectSchoolYear": "Select school year",
    "emptySchoolYear": "No classes or groups in this school year."
  },
  "classes": {
    "access": "Access",
    "addClass": "Add class or group",
    "addClassAccess": "Add team member",
    "addSchoolSubjectFromOtherLevels": "Add competences from other school levels",
    "addStudentsLabel": "Add student",
    "archive": "Archive class",
    "archiveBannerButton": "Who has access?",
    "archiveBannerDescription": "You can view all content, but you can't make any changes.",
    "archiveBannerTitle": "This class is in the archive.",
    "archiveBulk": "Archive classes",
    "archiveBulkAction": "Archive {count} class | Archive {count} classes",
    "archiveBulkConfirmDescription": "Content of archived classes can no longer be edited. Do you want to archive the selected classes?",
    "archiveBulkCurrentClass": "Class {className}",
    "archiveBulkInProgress": "Archiving classes…",
    "archiveBulkPartialFailure": "The following classes could not be archived: {classNames}",
    "archiveBulkStep": "{x} of {y}",
    "archiveBulkSuccess": "{count} class archived. | {count} classes archived.",
    "archiveBulkTitle": "Archive {count} class | Archive {count} classes",
    "archiveClassAddNote": "Add note",
    "archiveClassConfirmButton": "Yes, archive class",
    "archiveClassConfirmDescription": "Content of archived classes can no longer be edited. Are you sure you want to continue?",
    "archiveClassFinalNoteDescription": "Would you like to add a final note to the class?",
    "archiveClassFinalNotePlaceholder": "Note (optional)",
    "archiveClassFinalizeDescription": "Great, we have everything we need. Please review your details.",
    "archiveClassOverviewDescription": "Another school year is coming to an end. Let's wrap up class {className} together.",
    "archiveClassOverviewHelpText": "Completed classes can be found in the class selection under “My archive…”.",
    "archiveClassTeamDescription": "All content remains, but can no longer be edited.",
    "archiveInProgress": "Archiving class…",
    "bumpUp": "Move class up",
    "bumpUpClassSelectClassDescription": "Please select the class you want to move up.",
    "bumpUpClassSelectModeDescription": "Do you want to create a new class, or move a class up to the next school level?",
    "bumpUpDescription": "Move an existing class up to the next school level. Students and access rights are carried over.",
    "bumpUpDialogDescription": "It makes sense to archive the existing class before moving it up - that way the full year's history is preserved. But you can also move it up right away.",
    "bumpUpDialogTitle": "Archive class",
    "changeClasses": "Switch class",
    "changeClassesTooltip": "Here you can switch between your classes and the school administration.",
    "classAmount": "{count} class | {count} classes",
    "classInviteOverview": "Show summary",
    "create": "New class",
    "createAction": "Create class",
    "createClassTooltip": "Create your first class in the <b>school administration</b>.",
    "createCompetences": "Create competence templates",
    "createDescription": "Create a class with new students.",
    "createNewClass": "Create new class",
    "createSuccess": "{ name } was created",
    "data": "Class data",
    "delete": "Delete class",
    "demoBannerDescription": "Look around and feel free to try out all the features.",
    "demoBannerTitle": "You're in the Digidoo demo class.",
    "editClass": "Edit class",
    "editClassAccess": "Edit access",
    "editClasses": "Edit classes",
    "emptyStateDescription": "Create your first class now.",
    "emptyStateTitle": "No classes yet",
    "filteredEmptyStateDescription": "No classes were found for the selected school year.",
    "filteredEmptyStateTitle": "No classes for this school year",
    "finalizeClass": "Set up class",
    "finalizeClassAssessmentTypeDescription": "Which visualization do you want to use for performance assessments?",
    "finalizeClassStudentsDescription": "Now please add all your students.",
    "finalizeClassStudentsDescriptionNoPerm": "The following students are currently registered for your class. Please contact the administration to manage them.",
    "finalizeClassStudentsDescriptionNoStudentNoPerm": "No students have been added yet. Please contact the administration to create and manage them.",
    "finalizeDescription": "Great, we have everything we need. Please review your details.",
    "finalizeTitle": "Your class is all set up and you're ready to go.",
    "finalizedClassOverviewDescription": "Your class is ready and you can get started.",
    "finalizedClassOverviewDescriptionAlt": "Your class is almost set up. Please check the following info and you're ready to go.",
    "finalizedTitle": "Your class is ready and you can get started.",
    "futureSchoolYearConfirm": {
      "confirmButtonLabel": "Create anyway",
      "declineButtonLabel": "Choose current school year",
      "description": "You are creating this class in {selectedSchoolYearName}, although {currentSchoolYearName} is currently active. Do you really want to create the class in the future school year?",
      "title": "Future school year selected"
    },
    "general": "General",
    "generalDataDescription": "Let's create a new class. Please set the school level and name.",
    "goToClass": "Go to the class now",
    "groupedByClass": "Grouped by class",
    "groupedByGroup": "Grouped by group",
    "mobileDocumentationTip": {
      "description": "Have you tried Digidoo on your tablet or computer?",
      "title": "More room for documenting"
    },
    "moreClassesRefineSearch": "+{count} more class – refine your search | +{count} more classes – refine your search",
    "newSchoolLevel": "New school level",
    "newYear": "New school year",
    "nickname": "Nickname",
    "optionalName": "Name (optional)",
    "nicknamePlaceholder": "Owl class",
    "noStudents": "No existing students",
    "notGrouped": "Not grouped",
    "onlyBumpUp": "Only move class up a level",
    "performanceAssessmentDescription": "Which types of performance assessment do you want to use?",
    "performanceAssessmentValidationError": "All performance assessments must have a name.",
    "performanceAssessmentWarning": "The total weighting should be 100%.",
    "preSchoolPrefix": "P",
    "remove": "Delete class",
    "removeBulk": "Delete classes",
    "removeBulkConfirmHint": "All entered content of the selected classes will be deleted. Students will not be deleted.",
    "removeBulkConfirmText": "Please enter your first and last name or your email address to permanently delete class {classNames}. | Please enter your first and last name or your email address to permanently delete classes {classNames}.",
    "removeConfirmHint": "All entered content will be deleted. Students will not be deleted.",
    "removeConfirmInputPlaceholder": "First and last name or email",
    "removeConfirmText": "Please enter your first and last name or your email address to permanently delete the class \"{className}\".",
    "responsible": "Responsible",
    "schoolSubjectsDescription": "Which competences should be used?",
    "schoolSubjectsDescriptionAlt": "These competences will be used.",
    "schoolYearOverBannerDescription": "Do you want to archive the class?",
    "schoolYearOverBannerDescriptionNoPerm": "Please contact the administration if you'd like the class to be archived.",
    "schoolYearOverBannerTitle": "The school year is over.",
    "selection": {
      "selectedCount": "{count} class selected | {count} classes selected"
    },
    "status": {
      "active": "Active",
      "archived": "Archived"
    },
    "studentCount": "{count} students",
    "studentsAllInClass": "The name is already in the class | All {count} names are already in the class",
    "studentsAlreadyInClass": "{count} name is already in the class. | {count} names are already in the class.",
    "studentsDescription": "Please add all students of the class \"{className}\" here.",
    "studentsPlaceholder": "Add existing students",
    "tableStudentCount": "Students",
    "teamDescription": "Please choose who from your team has access.",
    "teamDescriptionAlt": "These people have access to the class.",
    "teamSelectLabel": "Add team members (name or email)",
    "teamSelectPlaceholder": "Name or email",
    "tipAdmin": "Here you can create and edit classes. You can see the responsible teachers and the number of students at a glance – both can be viewed and managed directly.",
    "tooltip": {
      "description": "Click here to create your first class."
    },
    "withoutClass": "Without class",
    "welcomeToYourNewClass": "Welcome to your new class",
    "year": "School year"
  },
  "competence": {
    "confirm": "Entries have already been created for this competence. Are you sure you want to edit this competence?",
    "count": "{count} competence | {count} competences",
    "edit": "Edit competence",
    "editPlural": "Edit competences",
    "openDomain": "Open competence domain {name}",
    "remove": "Remove competence",
    "searchPlaceholder": "Search competences …",
    "select": "Select competences",
    "showAll": "Show all competences"
  },
  "competenceAssessment": {
    "adjust": "Adjust",
    "descriptionPlaceholder": "Description (optional)",
    "selectCompetenceAssessmentDescription": "This performance assessment will be recorded using the selected competences.",
    "selectVisual": "Choose how your competence entries should be visualized.",
    "title": "Competence assessment",
    "titlePlaceholder": "Title (optional)",
    "visualDescription": "Visualization: ",
    "noVisualHint": "Create a visualization for this scope first."
  },
  "competenceIconGroup": {
    "activitiesAndNature": "Activities and nature",
    "creativityAndCommunication": "Creativity and communication",
    "geometryAndNumbers": "Geometry and numbers",
    "media": "Media",
    "peopleAndBodies": "People and body",
    "productivityAndLearning": "Productivity and learning",
    "symbols": "Symbols"
  },
  "competenceIcons": {
    "Admin": "Administrator",
    "Ai": "AI",
    "Angle": "Angle",
    "Approve": "Approve",
    "Archive": "Archive",
    "Area": "Area",
    "ArrowDown": "Arrow down",
    "ArrowLeft": "Arrow left",
    "ArrowRight": "Arrow right",
    "ArrowUp": "Arrow up",
    "Bandage": "Bandage",
    "Bicycle": "Bicycle",
    "Book": "Book",
    "BookOpen": "Open book",
    "Brush": "Brush",
    "Bubble": "Speech bubble",
    "BubbleCheck": "Speech bubble check",
    "BubbleHelp": "Speech bubble help",
    "BubbleProblem": "Speech bubble problem",
    "BubbleQuote": "Speech bubble quote",
    "Calendar": "Calendar",
    "Chart": "Chart",
    "Check": "Check",
    "CheckCircle": "Check circle",
    "Class": "Class",
    "Close": "Close",
    "Competence": "Competence",
    "Competence2": "Competence 2",
    "Competence3": "Competence 3",
    "Competence4": "Competence 4",
    "Competence5": "Competence 5",
    "Copy": "Copy",
    "CreditCard": "Credit card",
    "Cross": "Cross",
    "DavidStar": "Star of David",
    "Delete": "Delete",
    "Divide": "Divide",
    "Document": "Document",
    "DocumentCheck": "Document checked",
    "DocumentLines": "Document with lines",
    "DocumentPen": "Edit document",
    "Download": "Download",
    "Ear": "Ear",
    "Edit": "Edit",
    "Email": "Email",
    "Folder": "Folder",
    "Football": "Football",
    "Gaming": "Gaming",
    "Girl": "Girl",
    "Glasses": "Glasses",
    "Graduation": "Graduation",
    "Group": "Group",
    "Grow": "Grow",
    "Hammer": "Hammer",
    "Hand": "Hand",
    "HandsUp": "Hands up",
    "Heart": "Heart",
    "Help": "Help",
    "Highlight": "Highlight",
    "Home": "Home",
    "HomeAdd": "Add home",
    "Hundred": "Hundred",
    "Info": "Info",
    "Institution": "Institution",
    "Institution2": "Institution 2",
    "Invite": "Invitation",
    "Key": "Key",
    "Layers": "Layers",
    "Leaf": "Leaf",
    "Length": "Length",
    "Lightning": "Lightning",
    "Link": "Link",
    "Loader": "Loader",
    "Location": "Location",
    "Lock": "Lock",
    "Map": "Map",
    "MinusCircle": "Minus circle",
    "Moon": "Moon",
    "Move": "Move",
    "Music": "Music",
    "NewFolder": "New folder",
    "Notification": "Notification",
    "Owner": "Owner",
    "Percentage": "Percentage",
    "Phone": "Phone",
    "Play": "Play",
    "Plus": "Plus",
    "PlusCircle": "Plus circle",
    "PointRight": "Pointing right",
    "PointUp": "Pointing up",
    "Presentation": "Presentation",
    "Print": "Print",
    "Rate": "Rate",
    "Remove": "Remove",
    "Room": "Room",
    "Run": "Run",
    "Scissors": "Scissors",
    "Scribble": "Scribble",
    "Search": "Search",
    "See": "Eye",
    "Settings": "Settings",
    "Shield": "Shield",
    "Size": "Size",
    "Smile": "Smile",
    "Smile2": "Smile 2",
    "Snowflake": "Snowflake",
    "Speak": "Speak",
    "Stand": "Stand",
    "Star": "Star",
    "Sum": "Sum",
    "Sun": "Sun",
    "Sync": "Sync",
    "Temperature": "Temperature",
    "Ten": "Ten",
    "ThumbsUp": "Thumbs up",
    "Thousand": "Thousand",
    "ThreeD": "3D",
    "Time": "Time",
    "User": "User",
    "UserNew": "New user",
    "Video": "Video",
    "Warning": "Warning",
    "Web": "Web"
  },
  "competenceObservation": {
    "addCompetences": "Add competences",
    "allCompetencesAlreadyAddedToAllStudents": "All competences have already been added to all students.",
    "allCompetencesAlreadyAddedToStudent": "All competences have already been added to this student.",
    "chooseStudents": "Choose the students for the competence entry.",
    "competencePlaceholder": "Search competences/areas",
    "confirm": {
      "confirmButtonLabel": "Remove only here",
      "declineButtonLabel": "Remove for all",
      "description": "Do you want to remove the linked competence only for “{studentName}” or for all other students as well?",
      "title": "Remove competence"
    },
    "create": "New competence entry",
    "createShort": "New entry",
    "createYourFirstObservation": "Create your first entry",
    "delete": "Remove competence",
    "edit": "Edit competence entry",
    "noEligibleCompetences": "No competences available",
    "noEligibleStudents": "No students available",
    "notesPlaceholder": "Notes about the competence entry (optional)",
    "selectAll": "Select all",
    "studentPlaceholder": "Search",
    "trendUpsellAriaLabel": "Open subscription plans for the development curve",
    "trendUpsellDescription": "Make progress over time visible.",
    "trendUpsellTitle": "Development curve with Digidoo"
  },
  "cookieConsent": {
    "acceptAll": "Accept all",
    "acceptSelection": "Save selection",
    "categories": {
      "analytics": {
        "ariaLabel": "Enable analytics",
        "description": "Google Analytics (Google Ireland Limited) measures page views and interactions using cookies and online identifiers. This service loads only after your consent.",
        "title": "Analytics & website improvement"
      },
      "marketing": {
        "ariaLabel": "Enable marketing",
        "description": "Meta Pixel (Meta Platforms Ireland Limited) and TikTok Pixel (TikTok Technology Limited) record visits and interactions for advertising measurement and audience creation. When you are signed in, your email address and user ID are sent to Meta in hashed form so that registrations and purchases can be attributed to ads. Google Ads through Google Tag Manager loads only with additional analytics consent. Cookies, online identifiers and visited URLs may be processed and data may be transferred to third countries such as the USA.",
        "title": "Marketing & advertising measurement"
      },
      "necessary": {
        "ariaLabel": "Strictly necessary cookies are always active",
        "description": "These technologies enable the app and website to operate. We store your cookie choice for 180 days. Optional services remain disabled without consent.",
        "title": "Strictly necessary"
      }
    },
    "choose": "Choose",
    "close": "Close without changes",
    "description": "We use necessary cookies to operate the app and website. With your voluntary consent, we also use analytics and marketing services. You can reject all optional services and withdraw consent at any time via “Cookie settings”.",
    "settings": "Cookie settings",
    "title": "We use cookies.",
    "viewCookies": "Privacy policy",
    "withdrawalHint": "When you withdraw consent, we reload the page to stop tracking services that have already loaded."
  },
  "country": {
    "at": "Austria",
    "de": "Germany",
    "ch": "Switzerland"
  },
  "dataTable": {
    "allItemsLoaded": "No more entries",
    "items": {
      "classes": {
        "perPage": "Classes per page",
        "range": "{start}–{end} of {total} classes"
      },
      "documents": {
        "perPage": "Documents per page",
        "range": "{start}–{end} of {total} documents"
      },
      "entries": {
        "perPage": "Entries per page",
        "range": "{start}–{end} of {total} entries"
      },
      "groups": {
        "perPage": "Groups per page",
        "range": "{start}–{end} of {total} groups"
      },
      "members": {
        "perPage": "Members per page",
        "range": "{start}–{end} of {total} members"
      },
      "people": {
        "perPage": "People per page",
        "range": "{start}–{end} of {total} people"
      },
      "reports": {
        "perPage": "Reports per page",
        "range": "{start}–{end} of {total} reports"
      },
      "schoolYears": {
        "perPage": "School years per page",
        "range": "{start}–{end} of {total} school years"
      },
      "students": {
        "perPage": "Students per page",
        "range": "{start}–{end} of {total} students"
      },
      "users": {
        "perPage": "Users per page",
        "range": "{start}–{end} of {total} users"
      }
    },
    "loadingMore": "Loading more entries…",
    "next": "Next",
    "pagination": "Pagination",
    "previous": "Previous"
  },
  "date": {
    "select": "Select date",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "yesterday": "Yesterday"
  },
  "demoClassTour": {
    "addDocumentation": {
      "learningProgress": {
        "description": "Just start writing! Document your class's learning progress in just a few steps.",
        "title": "Document"
      },
      "report": {
        "description": "Click “{action}” at any time to create a new report.",
        "title": "Create a report"
      }
    },
    "classSelection": {
      "description": "Click your class to quickly switch between classes or go to school administration.",
      "title": "Your school"
    },
    "confirm": {
      "confirmButtonLabel": "Continue tour",
      "declineButtonLabel": "Go to school administration",
      "description": "If you switch to school administration, the Digidoo tour will end.",
      "title": "End tour?"
    },
    "generalNavigation": {
      "description": "Here you have quick access to important class areas at any time – like the analysis, reports, or class settings.",
      "title": "Your class"
    },
    "studentFilters": {
      "description": "Choose here whether you'd rather see an overall overview of your students or focus on a specific subject.",
      "title": "Subjects"
    },
    "studentTabs": {
      "description": "Here you can see your students' learning progress and development at a glance. Switch between <b>Entries, Overview and Reports</b> to view all details.",
      "title": "Student details"
    },
    "welcome": {
      "description": "We've already created a <b>demo class</b> for you. Take a look around and feel free to try out all the features.",
      "title": "Let's get to know Digidoo together."
    },
    "yourClass": {
      "description": "Here on the left you'll find all the students in your class. ",
      "title": "Your students"
    }
  },
  "dragAndDrop": {
    "cancelled": "Moving {name} cancelled.",
    "dropped": "Dropped {name} at position {position} of {total}.",
    "handleLabel": "Move {name}",
    "instructions": "Press space to pick up, use the arrow keys to move, press space to drop or escape to cancel.",
    "lifted": "Picked up {name}, position {position} of {total}.",
    "moved": "Position {position} of {total}.",
    "movedToList": "{list}, position {position} of {total}."
  },
  "emailWhitelist": {
    "addAllowedEmailsDialog": {
      "add": "Add",
      "addEmailsNote": "Add allowed email addresses to register new users\nFormat: test{'@'}test.com,test2{'@'}test.com",
      "cancel": "Cancel",
      "email": "Email address",
      "title": "Add allowed email addresses"
    },
    "create": "New email whitelist",
    "table": {
      "email": "Email address"
    },
    "title": "Email whitelist"
  },
  "entityAppearance": {
    "background": "Background color",
    "colors": {
      "amber": "Amber",
      "blue": "Blue",
      "brown": "Brown",
      "green": "Green",
      "lightGray": "Light gray",
      "lime": "Lime",
      "mutedPurple": "Muted purple",
      "orange": "Orange",
      "orchid": "Orchid",
      "papaya": "Papaya",
      "pink": "Pink",
      "purple": "Purple",
      "red": "Red",
      "sand": "Sand",
      "skyBlue": "Sky blue",
      "turquoise": "Turquoise",
      "white": "White",
      "yellow": "Yellow"
    },
    "defaultTone": "Default",
    "dropImage": "Drop an image here or",
    "edit": "Edit appearance",
    "emoji": "Emoji",
    "icon": "Icon",
    "image": "Image",
    "imageDecodeError": "This image could not be opened. Please choose another file.",
    "imageLoading": "Opening image…",
    "imageSizeError": "Please choose an image no larger than 1 MB.",
    "imageTypeError": "Please choose a JPG, PNG, WebP or GIF image.",
    "loadError": "The emoji catalog could not be loaded.",
    "loading": "Loading emojis…",
    "noResults": "No results",
    "removeImage": "Remove image",
    "search": "Search",
    "selectImage": "choose a file",
    "skinTone": "Skin tone",
    "text": "Text",
    "uploadImage": "Upload file…"
  },
  "errorMessages": {
    "BILLING_CHECKOUT_BLOCKED": "There is still an open invoice or unfinished subscription. Please pay the current invoice first or manage your subscription in billing.",
    "BILLING_PRODUCT_ALREADY_EXISTS": "A product for this product type already exists.",
    "CLASS_ALREADY_ARCHIVED": "This class has already been completed. Changes are no longer possible.",
    "CLASS_HAS_STILL_STUDENTS": "This class can't be deleted. Please remove all assigned students first.",
    "COMPETENCE_ASSESSMENT_SUBJECT_ACCESS_DENIED": "Cannot edit: this competence assessment has observations in subjects you cannot access.",
    "CONTACT_OWNER_TO_UPGRADE": "Your school needs to upgrade its subscription. Please contact your school management.",
    "DEMO_CLASS_COPY_FAILED": "The demo class could not be created. Please try again later.",
    "EMAIL_CHANGE_MAIL_ALREADY_SENT": "An email has already been sent. Try again in a few minutes",
    "EMAIL_COOLDOWN_ACTIVE": "We recently sent this person a similar email. Please wait before trying again.",
    "EMPTY_DTO": "Invalid input data",
    "FEATURE_DISABLED": "This feature is not enabled.",
    "FILE_ALREADY_EXISTS": "This file already exists",
    "FILE_SIZE_LIMIT_EXCEEDED": "The file is too large",
    "FILE_TYPE_INVALID": "This file type is not supported",
    "FILE_VALIDATION_FAILED": "The file is invalid",
    "FOREIGN_KEY_CONSTRAINT": "Cannot delete: linked data exists",
    "GET_FILE_ERROR": "The file could not be loaded",
    "IMPORT_FAILED": "The file could not be imported",
    "INVALID_EMAIL_CHANGE_CODE": "The code is invalid, expired, or has already been used. Please request a new code.",
    "INVALID_IMPLICIT_DELETION": "This action would lead to unintended deletions",
    "INVALID_INVITATION_CODE": "The invitation code is invalid, expired, or has already been used. Please request a new code.",
    "INVALID_LOGIN": "Invalid login credentials",
    "INVALID_PARAMETERS": "Invalid parameters",
    "INVALID_PASSWORD_RESET_CODE": "The password reset link is invalid or expired",
    "INVALID_REFERRAL_CODE": "The referral link is invalid or has expired.",
    "INVALID_SCHOOL_YEAR": "Invalid school year",
    "INVALID_TOKEN": "Your session has expired. Please log in again",
    "INVALID_USER_INVITATION": "The user invitation is invalid",
    "INVITATION_RECIPIENT_DEACTIVATED": "Invitations cannot be sent to deactivated accounts.",
    "LOCAL_AUTH_PROVIDER_NEEDED": "Password reset is not available. Please contact support.",
    "MISSING_TENANT_ID": "Your session is invalid. No school could be assigned.",
    "NOT_FOUND": "The requested resource was not found",
    "NOT_IMPLEMENTED": "This feature is not available yet",
    "NO_PERMISSION": "You don't have permission for this action",
    "PASSWORD_MISMATCH": "Invalid password",
    "PASSWORD_RESET_MAIL_ALREADY_SENT": "A password reset email has already been sent. Please wait a moment before trying again",
    "PDFGEN_FAILED_REQUEST": "The PDF could not be generated. Please try again later.",
    "PDFGEN_GENERIC_ERROR": "The PDF could not be generated. Please try again later.",
    "PDFGEN_TIMEOUT_ERROR": "Generating the PDF took too long. Please try again later.",
    "PERFORMANCE_ASSESSMENT_SUBJECT_ACCESS_DENIED": "Cannot edit or delete: this assessment has entries in subjects you cannot access.",
    "PLAN_UPGRADE_REQUIRED": "You need to upgrade your subscription.",
    "REFERRAL_ALREADY_ATTRIBUTED": "A referral has already been applied to your account.",
    "REFERRAL_GRANT_EXCEEDS_MAXIMUM": "The credit would exceed the maximum referral discount.",
    "REFERRAL_NOT_ELIGIBLE": "This referral can't be applied to your account.",
    "REFERRAL_SELF_REFERRAL": "You can't use your own referral link.",
    "RELEASE_ID_ALREADY_EXISTS": "Release ID already exists.",
    "REPORT_ALREADY_COMPLETED": "This report has already been completed. Changes are no longer possible.",
    "REPORT_COVER_IMAGE_MISSING": "The cover sheet needs a picture before the report can be completed.",
    "REPORT_NO_CLASS_ASSOCIATION": "This report isn't assigned to a class.",
    "SCHOOL_CLASS_ALREADY_ASSIGNED_TO_YEAR": "This class is already assigned to a school year",
    "SCHOOL_YEAR_ALREADY_EXISTS": "This school year already exists",
    "SCHOOL_YEAR_IN_USE": "The school year is already in use",
    "STUDENT_NO_SUBJECT_RELATION": "This subject is not available for this student",
    "TEMPLATE_SET_ALREADY_EXISTS": "A competence template with this country, state, school type, language, version and source already exists.",
    "TENANT_ALREADY_EXISTS": "A school with this name already exists",
    "TENANT_NOT_CONNECTED_TO_STATE": "Your school isn't assigned to a state yet. It can be added in the school settings.",
    "TOO_MANY_LEVELS": "Too many levels",
    "TOO_MANY_REQUESTS": "Too many requests. Please wait a moment",
    "UNKNOWN": "An unexpected error occurred",
    "UNKNOWN_REGISTRATION": "Your email address is not approved. To get access, please contact support.",
    "USER_ALREADY_EXISTS": "This email address is already in use.",
    "USER_DEACTIVATED": "This account has been deactivated. Please contact support.",
    "VALIDATION_FAILED": "Please check your input",
    "WEEKLY_REPORT_FAILED": "The weekly report could not be created or contains errors.",
    "invalidAbbreviation": "The abbreviation must be between 1 and 3 characters long",
    "invalidColor": "The color must be in a valid hex format",
    "invalidDate": "The specified date is invalid",
    "invalidEmail": "This email address doesn't seem to have a valid format",
    "invalidNumber": "Invalid number",
    "loginFailed": "Login failed",
    "maxLength": "Must be at most {max} characters long",
    "networkError": "An error occurred. Please try again later.",
    "noAbbreviation": "Please enter an abbreviation",
    "noAddressLine1": "Please enter an address",
    "noConditions": "Please agree to the terms and conditions and the privacy policy",
    "noEmail": "Please enter an email address",
    "noFirstName": "Please enter a first name",
    "noLastName": "Please enter a last name",
    "noName": "Please enter a name",
    "noOwnEmail": "Please enter your email address",
    "noPassword": "Please enter your password",
    "noSchoolSelected": "Please select a school",
    "noTitle": "Please enter a title",
    "noUserRoleType": "Please select a role",
    "passwordMismatch": "Passwords don't match",
    "passwordTooShort": "The password must be at least {minLength} characters long",
    "totpCodeWrong": "The code is invalid"
  },
  "feedback": {
    "accountDeactivation": "Account deactivation",
    "appVersion": "App version",
    "category": "Category",
    "markHandled": "Mark as handled",
    "markOpen": "Mark as open",
    "message": "Message",
    "source": "Source",
    "starRating": "Star rating",
    "statusHandled": "Handled",
    "statusOpen": "Open",
    "title": "Feedback",
    "userAgent": "User Agent",
    "view": "View feedback"
  },
  "general": {
    "activate": "Activate",
    "active": "Active",
    "add": "Add",
    "addComments": "Add comments",
    "additionalStudentCount": "+{count} more",
    "allClassesAndGroups": "All classes and groups",
    "classesAndGroups": "Classes and groups",
    "description": "Description",
    "addStudents": "Add students",
    "all": "All",
    "allEntries": "All entries",
    "allStates": "All states",
    "and": "and",
    "archive": "Archive",
    "back": "Back",
    "billing": "Payment & billing",
    "billingCustomerId": "Billing ID",
    "brand": "Digidoo",
    "bumpUp": "Move up",
    "calculation": "Included in analysis",
    "cancel": "Cancel",
    "cancelEntry": "Cancel entry",
    "cancelEntryDescription": "If you close this window, all changes made so far will be lost. Do you still want to cancel the entry?",
    "choose": "Choose",
    "class": "Class",
    "classTeam": "Class team",
    "classes": "Classes",
    "clearFilters": "Remove filters",
    "close": "Close",
    "competenceEntry": "Competence entry",
    "competenceGrid": "Competence grid",
    "competenceObservations": "Competence entry | Competence entries",
    "competences": "Competences",
    "contact": "Contact",
    "contactUs": "Contact us",
    "continue": "Continue",
    "continueEditing": "Continue editing",
    "copy": "Copy",
    "country": "Country",
    "create": "Create",
    "createSuccess": "{ count } entry added! | { count } entries added!",
    "created": "Created",
    "createdAt": "Created on",
    "date": "Date",
    "deactivated": "Deactivated",
    "delete": "Delete",
    "deleteSuccess": "Entry deleted!",
    "demoClass": "Demo class",
    "details": "Details",
    "discardChanges": "Discard changes",
    "discardChangesDescription": "You have made changes, but have not saved them with \"Done\" yet. If you close this window, these changes will be lost. Do you still want to discard the changes?",
    "discardChangesTitle": "Discard changes?",
    "done": "Done",
    "download": "Download",
    "downloadAll": "Download all",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "editSuccess": "Entry edited!",
    "email": "Email",
    "fileType": "{format} file",
    "findOutMore": "Find out more",
    "firstName": "First name",
    "goToOverview": "Go to overview",
    "group": "Grouping",
    "groups": "Groups",
    "hideDetails": "Hide details",
    "imageFileType": "{format} image",
    "import": "Import",
    "inherited": "Inherited",
    "journal": "History",
    "language": "Language",
    "lastName": "Last name",
    "later": "Later",
    "learnMore": "Learn more",
    "learningProgress": "Learning progress",
    "legalNotice": "Legal notice",
    "logout": "Log out",
    "maxFileSize": "max. file size: {size}",
    "more": "more",
    "moreResultsRefineSearch": "+{count} more result – refine your search | +{count} more results – refine your search",
    "multiEntry": "Entry",
    "name": "Name",
    "newEntry": "New entry",
    "no": "No",
    "noActions": "No actions available",
    "noEntries": "No entries",
    "noEntriesYet": "No entries yet",
    "noOptions": "No options available",
    "noResults": "No results",
    "noSeatsAvailableForInvitation": "There is no free seat left to invite another member.",
    "or": "or",
    "order": "Order",
    "performanceAssessment": "Performance assessment | Performance assessments",
    "performanceVisual": "Visualization",
    "print": "Print",
    "printAll": "Print all",
    "recommended": "recommended",
    "remove": "Remove",
    "retry": "Try again",
    "role": "Role",
    "save": "Save",
    "schoolLevel": "School level",
    "schoolLevelCount": "1 school level | {count} school levels",
    "schoolLevelOption": "School level { schoolLevel }",
    "schoolLevelPreSchool": "Pre-school level",
    "schoolLevelsContinuousHint": "School levels must be continuous — no gaps allowed (e.g. 1–6).",
    "schoolName": "School",
    "schoolTemplate": "School template",
    "schoolTerm": "Semester",
    "schoolType": "School type",
    "schoolYearPeriod": "Period",
    "schoolYears": "School years",
    "search": "Search",
    "securityAndPrivacy": "Security & privacy",
    "select": "Select",
    "selectAll": "Select all",
    "selectEntryType": "Select entry type",
    "show": "Show",
    "showAll": "Show all",
    "showDetails": "Show details",
    "skip": "Skip",
    "startTour": "Start tour",
    "state": "State",
    "status": "Status",
    "student": "Student",
    "studentCount": "{count} student | {count} students",
    "students": "Students",
    "subjectOrSubjects": "{count} subject | {count} subjects",
    "subjects": "Subjects",
    "switchToClass": "Switch to class",
    "teachers": "Teachers",
    "team": "Team",
    "template": "Template",
    "templateSource": "Template source",
    "title": "Title",
    "today": "Today",
    "updated": "Edited",
    "updatedAt": "Edited on",
    "uploadSizeExceeded": "The file is too large. Please choose a file up to {size}.",
    "uploadTypeInvalid": "This file type is not supported. Please choose one of these file types: {fileTypes}.",
    "willBeInvited": "will be invited to the team",
    "willBeInvitedDescription": "The teacher will then receive an invitation to <b>join your team</b> and can get started in this class right away.",
    "xOfY": "{ x } of { y }",
    "yes": "Yes",
    "completed": "Completed"
  },
  "gradeCalculation": {
    "activation": {
      "activatedToast": "Grade calculation activated",
      "description": "Digidoo calculates a transparent grade recommendation from performance assessments and their weighting.",
      "descriptionLink": "weighting",
      "descriptionPrefix": "Digidoo calculates a transparent grade recommendation from your performance assessments and their ",
      "descriptionSuffix": ".",
      "descriptionWithLink": "Digidoo calculates a transparent grade recommendation from your performance assessments and their {link}.",
      "inactive": "Grade recommendations are not active.",
      "title": "Enable automatic grade calculation"
    },
    "decreaseWeighting": "Decrease weighting",
    "disclaimer": "Calculated grades are meant as guidance. The final assessment and responsibility for grading remain with the teacher.",
    "editWeighting": "Edit weighting",
    "entryTag": "Weighting",
    "entryTagDescription": "Define whether and how strongly this performance assessment affects the overall grading.",
    "gradeLevels": {
      "addLevel": "Add grade",
      "bestGrade": "Best grade",
      "bestGradeLower": "best grade",
      "defaultName": "Grade",
      "descriptionPlaceholder": "Description",
      "lowerIsBetterLabel": "Lower number is the best grade",
      "namePlaceholder": "Name",
      "orderDescription": "Which order should the grade calculation use?",
      "orderTitle": "Order",
      "reverseAction": "Reverse order",
      "reverseConfirmDescriptionRich": "You are reversing the grade order. {fromGrade} will become {toGrade}. Existing grade recommendations for all active classes will be recalculated.",
      "reverseConfirmTitle": "Reverse order",
      "title": "Grades",
      "worstGrade": "Worst grade",
      "worstGradeLower": "worst grade"
    },
    "increaseWeighting": "Increase weighting",
    "noWeightingContext": "There are no performance assessments in this context yet.",
    "recommendation": {
      "achieved": "Achieved",
      "asOfDate": "as of {date}",
      "asOfToday": "as of today",
      "assessmentLabel": "Performance assessment",
      "assessmentsTitle": "Performance assessments",
      "assessmentsTitleWithCount": "{count} entry | {count} entries",
      "contribution": "Contribution",
      "dialogExplanation": "{assessment} currently has the strongest impact on the recommendation with a weighting of {weighting}%.",
      "dialogExplanationPartial": "The recommendation currently covers {availableWeight}% of the available weighting. {assessment} has the strongest impact right now.",
      "dialogFallback": "Rated performance assessments are already available for this recommendation.",
      "exactGrade": "Exact grade",
      "gradeProposal": "Grade proposal",
      "includedEntries": "Entries",
      "meanGrade": "Mean",
      "moreAboutRecommendation": "More about the grade recommendation",
      "noData": "No data",
      "observationsLabel": "Observations",
      "shortTitle": "Grade",
      "subjectCardNoRecommendation": "No grade recommendation",
      "subjectCardObservationCount": "{ count } observation | { count } observations",
      "subjectCardRecommendationPrefix": "Recommendation:",
      "subjectCardRecommendationValue": "{grade}",
      "subjectCardRecommendationValueWithName": "{grade} ({name})",
      "title": "Grade recommendation",
      "titleAverage": "Grade average",
      "totalAchieved": "Total achieved",
      "widgetDescription": "Based on the current weighting, the current recommendation is grade {grade}. {assessment} has the strongest influence.",
      "widgetDescriptionAverageOverall": "Based on all recommendations, the grade average is {exactGrade} – rounded to {grade}.",
      "widgetDescriptionEmpty": "We need at least {entry} to calculate a grade recommendation.",
      "widgetDescriptionEmptyEntry": "one performance assessment entry",
      "widgetDescriptionFallback": "A grade recommendation is already available based on the current weighting.",
      "widgetDescriptionResult": "Based on the weighting and distribution, the overall result is {grade}.",
      "widgetDescriptionResultWithDetailsPlural": "Based on your {count} entries and their weighting, the result {asOf} is {grade}.",
      "widgetDescriptionResultWithDetailsSingular": "Based on your entry and its weighting, the result {asOf} is {grade}.",
      "widgetGradeLabel": "Grade {grade}",
      "widgetGradeLabelWithName": "Grade {grade} ({name})",
      "widgetHideSensitiveData": "Hide sensitive data",
      "widgetShowDetails": "Show details",
      "widgetShowSensitiveData": "Show sensitive data"
    },
    "schoolLevels": {
      "confirmAction": "Update",
      "confirmDescription": "Automatic grade calculation will be active for {scope}.",
      "confirmRemoveAction": "Disable",
      "confirmRemoveDescriptionRich": "Automatic grade calculation will only remain active for {scope}.",
      "confirmRemoveTitle": "Disable grade calculation",
      "confirmTitle": "Update grade calculation",
      "dialogDescription": "For which school levels should grade recommendations be used?",
      "dialogTitle": "School levels",
      "edit": "edit",
      "listMultiple": "{items} and {lastItem}",
      "listPair": "{firstItem} and {secondItem}",
      "scopeAll": "all school levels",
      "scopeMultiple": "school levels {schoolLevels}",
      "scopePreSchoolAndMultiple": "the pre-school level and school levels {schoolLevels}",
      "scopePreSchoolAndSingle": "the pre-school level and school level {schoolLevel}",
      "scopeSingle": "school level {schoolLevel}",
      "scopeSinglePreSchool": "the pre-school level",
      "summary": "Automatic grade calculation is active for {scope}."
    },
    "tags": {
      "default": "Normal weighting",
      "excluded": "Do not weight",
      "high": "Higher weighting",
      "higher": "Highest weighting",
      "lower": "Lower weighting"
    },
    "tagsDescription": "These prepared tags control how strongly individual performance assessments influence the grade calculation and keep the model open for future admin configuration.",
    "tagsTitle": "Tags for performance assessments",
    "tip": "Here you can enable automatic grade calculation for <b>{school}</b> and define the default visualization for the grade recommendation.",
    "title": "Grades",
    "visual": {
      "description": "Choose how the entries should be visualized in the grade recommendation.",
      "label": "School grades",
      "title": "Visualization"
    },
    "weightingContext": {
      "default": "All subjects",
      "inherited": "Inherits the default weighting for {subject}",
      "subjectSpecific": "Subject-specific for {subject}"
    },
    "weightingDescription": "The weighting is used for the automatic grade recommendation.",
    "weightingDialogTitleDefault": "Weighting for all subjects",
    "weightingDialogTitleSubject": "Weighting for {subject}",
    "weightingTotal": "Total weighting: {total}%",
    "weightingValidation": "The weighting must total exactly 100%. Current total: {total}%.",
    "weightingValidationCompact": "The weightings currently add up to {total} % instead of 100 %. Please adjust the values.",
    "weightingZeroInfo": "Performance assessments with 0% weighting are not considered for grade calculation."
  },
  "groups": {
    "abbreviation": "Abbreviation",
    "archive": "Archive group",
    "archiveBannerTitle": "This group is in the archive.",
    "archiveConfirmButton": "Yes, archive group",
    "archiveConfirmDescription": "Content of archived groups can no longer be edited. Are you sure you want to continue?",
    "archiveInProgress": "Archiving group…",
    "archiveOverviewDescription": "Another school year is coming to an end. Let's wrap up group {className} together.",
    "bumpUp": "Move group up",
    "bumpUpDialogDescription": "It makes sense to archive the existing group before moving it up - that way the full year's history is preserved. But you can also move it up right away.",
    "bumpUpDialogTitle": "Archive group",
    "canManageAccessRightsTooltip": "The teacher can add other colleagues to the group and manage their access rights.",
    "canManageStudentsTooltip": "The teacher can add, edit, and remove students from the group at any time.",
    "collectiveRatingWholeGroup": "Collective rating for the whole group",
    "createGroupAction": "Create group",
    "createNewGroup": "Create new group",
    "createSuccess": "{ name } was created",
    "data": "Group data",
    "delete": "Delete group",
    "deleteBlockedByStudents": "This group can't be deleted. Please remove all assigned students first.",
    "editGroup": "Edit group",
    "finalizedOverviewDescription": "Your group is ready and you can get started.",
    "finalizedOverviewDescriptionAlt": "Your group is almost set up. Please check the following info and you're ready to go.",
    "futureSchoolYearDescription": "You are creating this group in the {selectedSchoolYearName}, although the {currentSchoolYearName} is currently active. Do you really want to create the group in the future school year?",
    "generalDataDescription": "Let's create a new group. Please set the school year and name.",
    "group": "Group",
    "groupAmount": "{count} group | {count} groups",
    "levelAndGroup": "School level / group",
    "myGroup": "My group",
    "onlyBumpUp": "Only move group up a level",
    "performanceAssessmentTipTeacher": "Here you can see which type of performance documentation is used in your group <b>{currentClass}</b>. Depending on your permissions, you can edit it or add new documentation types.",
    "performanceVisualBlockedByArchived": "You can't change the visualization because the group is archived.",
    "performanceVisualTipTeacher": "Here you can see the visualizations used for performance documentation in your group <b>{currentClass}</b>. Depending on your permissions, you can add more visualizations.",
    "proAccessRightsTooltip": "With a Digidoo subscription, you decide who can manage students, competences, performance assessments, and access rights in each group.",
    "remove": "Delete group",
    "removeConfirmHint": "All entered content will be deleted. Students will not be deleted.",
    "removeConfirmText": "Please enter your first and last name or your email address to permanently delete the group \"{className}\".",
    "reportNoStudents": "Your group doesn't have any students yet. Add students so you can create a report.",
    "reportNoSubjects": "Your group doesn't have any subjects yet. Add subjects so you can create a report.",
    "schoolSubjectDescription": "Please choose the subject for your group.",
    "schoolYearOverBannerDescription": "Do you want to archive the group?",
    "schoolYearOverBannerDescriptionNoPerm": "Please contact the administration if you'd like the group to be archived.",
    "statisticsTip": "The Digidoo flower gives you a visual overview of the competence level of your group <b>{currentClass}</b>. Analyze individual subjects and competences in detail and see at a glance how all entries are distributed. Refine your analysis with targeted filters.",
    "studentsAllInGroup": "The name is already in the group | All {count} names are already in the group",
    "studentsAlreadyInGroup": "{count} name is already in the group. | {count} names are already in the group.",
    "studentsDescription": "Please add all students of the group \"{className}\" here.",
    "studentsStepDescription": "Now add all students of the group.",
    "switchToGroup": "Switch to group",
    "switchToGroupAfterCreate": "Switch to the group right away",
    "team": "Group team",
    "teamEmptyStateTitle": "No group team yet",
    "teamMemberRemoveDescription": "Are you sure you want to remove this teacher from the group?",
    "teamMemberWillBeInvitedDescription": "The teacher will receive an invitation to <b>join your team</b> and can then get started in this group right away.",
    "teamMembersDescriptionAlt": "These people have access to the group.",
    "teamTip": "Here you can see all teachers who teach in your group <b>{currentClass}</b>. Permissions and subject access can be viewed here and can only be changed by admins. Depending on your own permissions, you can add more teachers to the group.",
    "timelineSetupNoStudentSubjectsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for {studentName} in group \"{className}\", but no subjects are linked for this student yet and I do not have permission to add them myself.\n\nPlease link subjects for this student so I can start working:\n{classSetupLink}\n\nThank you!",
    "timelineSetupNoStudentSubjectsRequestMailSubject": "Please link subjects for {studentName} in group \"{className}\"",
    "timelineSetupNoStudentsMessage": "Learning progress entries need students. Add them first or link existing students to this group.",
    "timelineSetupNoStudentsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for group \"{className}\", but there are no students linked to this group yet and I do not have permission to add them myself.\n\nPlease add or link students for this group so I can start working:\n{classSetupLink}\n\nThank you!",
    "timelineSetupNoStudentsRequestMailSubject": "Please add students for group \"{className}\"",
    "timelineSetupNoSubjectsMessage": "Each learning progress entry needs a subject. You don't have access to a subject in this group yet.",
    "tipAdmin": "Here you can create and manage groups. Groups let you bring students together across classes and school levels – for example for support, choir or performance groups.",
    "tipAll": "Here you can see the timeline of all entries of your group <b>{currentClass}</b> at a glance. Get a precise overview and filter by subject.",
    "tipSettings": "Here you can see all students of your group <b>{currentClass}</b>. Depending on your permissions, you can manage their data or add new students to the group.",
    "withoutGroup": "Without group",
    "welcomeToYourNewGroup": "Welcome to your new group",
    "wholeGroup": "Whole group",
    "wholeGroupWithName": "Group {name}"
  },
  "growth": {
    "firstEntrySuccess": {
      "bodyInvite": "Would you like to invite your team now\nso you can get started together?",
      "bodySimple": "You created your first entry.",
      "closeCta": "Close",
      "doneCta": "Done",
      "goToClassCta": "Go to my class",
      "hint": "This only takes about 5 minutes.",
      "inviteCta": "Invite my team",
      "laterCta": "I’ll do it later",
      "requestClassCta": "Request a class",
      "requestClassHint": "You don’t have a class assigned yet. Please request access from the administration.",
      "requestClassMailBody": "Hi {firstNameReceiver},\n\n{fullNameSender} is already registered with Digidoo but hasn’t been assigned to a class yet.\n\nPlease create a class or assign them to an existing one.\n\nYou can manage the class assignment here:\n{classAssignmentLink}\n\nThank you!",
      "requestClassMailSubject": "Please create a class for me",
      "secondEntryCta": "Create second entry",
      "title": "Great! Your first entry is done."
    },
    "popup": {
      "createClass": {
        "body": "Get started now and document\nlearning progress directly in your class.",
        "close": "Close",
        "hint": "This only takes about 2 minutes.",
        "primary": "Create class",
        "secondary": "I’ll do it later",
        "title": "Create your first\nclass now."
      },
      "decision": {
        "body": "Digidoo can be used solo or with a team. Let us know what fits you right now.",
        "hint": "🙂 You can change this at any time.",
        "primary": "I’ll work solo for now",
        "secondary": "I want to work with a team",
        "title": "How do you want to use Digidoo?"
      },
      "firstEntry": {
        "body": "Experience Digidoo best by creating\none real entry.",
        "close": "Close",
        "hint": "This only takes about 2 minutes.",
        "primary": "Start first entry",
        "secondary": "Later",
        "title": "Start with your\nfirst entry now."
      },
      "schoolSetup": {
        "body": "Competences, team, students and\nclasses.",
        "close": "Close",
        "hint": "This only takes about 2 minutes.",
        "primary": "Set up school",
        "secondary": "I’ll do it later",
        "title": "Great, let’s set up\nyour school."
      }
    },
    "tooltip": {
      "firstEntry": {
        "body": "Click here to create your first entry.",
        "title": "Let’s go!"
      }
    }
  },
  "inviteUser": {
    "access": {
      "optional": "(optional)",
      "teacherLabel": "The invited people have access to:"
    },
    "admin": {
      "description": "Invite one or more administrators. They automatically get access to all classes.",
      "title": "Invite administrators"
    },
    "error": {
      "alreadyInvited": "This person has already been invited.",
      "alreadyMember": "This person is already a member of your school."
    },
    "external": {
      "description": "Invite people outside your school. External people have access to selected competences.",
      "title": "Invite external people"
    },
    "teacher": {
      "description": "Invite one or more colleagues. If you want, you can assign them directly to a class.",
      "title": "Invite teachers"
    }
  },
  "help": {
    "description": "Need help or have ideas on how Digidoo could be even better?",
    "faq": "Help",
    "feedback": "Feedback",
    "feedbackMail": {
      "body": "Hello Digidoo team,\nI have the following feedback for you:\n\n\n\nBest regards,\n{ name }\n\n\nTechnical details, please do not change:\n",
      "subject": "Feedback on Digidoo"
    },
    "fixedArticles": {
      "videoTutorials": {
        "question": "Video tutorials",
        "sectionTitle": "Video tutorials"
      },
      "welcome": {
        "question": "Welcome",
        "sectionTitle": "Welcome"
      }
    },
    "mostFrequentQuestions": "Frequently asked questions",
    "nothingSelected": "Nothing selected",
    "privacy": "Privacy",
    "rating": {
      "anchorText": "Rate Digidoo",
      "description": "Your feedback helps us keep improving Digidoo.",
      "directFeedback": "Or give us feedback directly",
      "engagementDescription": "Great! You've already created {count} {entity}.",
      "entities": {
        "competenceEntry": "competence entries",
        "performanceAssessmentEntry": "performance assessments",
        "report": "reports"
      },
      "feedbackEntityDescription": "Great! You already have {count} {entity}. How do you like Digidoo so far?",
      "final": "Thank you. We've received your feedback.",
      "greatRatingDescription": "We're glad Digidoo supports you in your everyday school life.",
      "greatRatingTitle": "Thanks for your positive feedback 🎉",
      "improveRatingDescription1Star": "We're sorry that Digidoo hasn't won you over yet. What can we improve?",
      "improveRatingDescription2And3Stars": "Please tell us briefly what didn't work well.",
      "improveRatingTitle": "Thanks for your feedback.",
      "rateNow": "Rate now",
      "rateOnGoogle": "Rate us on Google",
      "recommend": "Recommend Digidoo",
      "sendFeedback": "Send feedback",
      "sendSuccess": "Thank you for your feedback!",
      "textPlaceholder": "Got feedback?",
      "title": "How do you like Digidoo?"
    },
    "title": "Help & contact",
    "tooltipDescription": "Click here anytime to learn more about Digidoo, watch video tutorials, or contact us.",
    "tooltipTitle": "Help and support",
    "version": "Digidoo { version }",
    "videos": "Video tutorials",
    "webinar": {
      "bookSlot": "Choose a time",
      "description": "We're happy to answer your questions and help you get familiar with Digidoo.",
      "title": "Webinar"
    }
  },
  "imageAlt": {
    "digidooLogo": "Digidoo logo",
    "digidooUpgradeIcon": "Digidoo upgrade icon",
    "logo": "Logo"
  },
  "asyncOperations": {
    "error": "Execution failed",
    "pending": "Creating…",
    "success": "Completed successfully"
  },
  "providerEmails": {
    "allTypes": "All email types",
    "deactivatedMemberId": "Deactivated member ID",
    "deliveryDetail": "Delivery details",
    "deliveryState": "Delivery status",
    "deliveryStateAt": "Delivery status updated",
    "deliveryStates": {
      "bounced": "Bounced",
      "complained": "Complaint",
      "delayed": "Delayed",
      "delivered": "Delivered",
      "rejected": "Rejected"
    },
    "emptyDescription": "There are no email audit records for this selection.",
    "error": "Sending error",
    "idFilter": "ID: {id}",
    "loadError": "Emails could not be loaded.",
    "loading": "Loading emails…",
    "messageId": "Message ID",
    "metadata": {
      "billingSubscriptionId": "Subscription ID",
      "targetClassId": "Class ID",
      "tenantId": "School ID"
    },
    "noTracking": "No tracking data",
    "openUser": "Open in users",
    "providerMessageId": "Provider message ID",
    "recipient": "Recipient",
    "recipientUser": "Recipient account",
    "sendStates": {
      "error": "Failed",
      "sending": "Sending",
      "success": "Sent"
    },
    "sender": "Sender",
    "status": "Sending status",
    "title": "Emails",
    "type": "Email type"
  },
  "schoolSubject": {
    "title": "Subjects",
    "abbreviation": "Abbreviation",
    "schoolLevel": "School level",
    "competenceDomains": "Competence domains",
    "assignedTypes": "Assigned types",
    "onlyWithoutTypes": "Only without type",
    "onlyNotClassifiable": "Only non-classifiable",
    "allSchoolLevels": "All school levels",
    "allSchoolTypes": "All school types",
    "classify": "Classify with LLM",
    "classifyPending": "Classifying subject …",
    "classifyDone": "Subject classified",
    "classifyError": "Classification failed",
    "classifyAllPending": "Classifying subjects …",
    "classifyAllDone": "Classification finished",
    "classifyAllError": "Classification failed",
    "selectedCount": "{count} subject selected | {count} subjects selected",
    "editTypes": "Edit types",
    "editTypesHint": "Choose the subject types for this subject.",
    "noTypes": "No types"
  },
  "schoolSubjectType": {
    "title": "Subject types",
    "key": "Key",
    "label": "Label",
    "order": "Order",
    "deleteConfirm": "Do you really want to delete the subject type \"{name}\"?",
    "classifyAll": "Run classification",
    "classifyAllConfirm": "All subjects will be reclassified in the background using existing subjects and synonyms (no LLM). Continue?",
    "classifyStarted": "Classification has been started."
  },
  "externalMaterial": {
    "title": "External material",
    "externalId": "External ID",
    "family": "Family",
    "logo": "Logo",
    "logoSecurityHint": "Images for user-created apps are not loaded for security reasons.",
    "logoUploadHint": "Save the entry first to upload a logo.",
    "subjectSource": "Subject",
    "schoolLevels": "School levels",
    "countries": "Countries",
    "anyCountry": "All countries",
    "languages": "Languages",
    "anyLanguage": "All languages",
    "subjectTypes": "Subject types",
    "noSubjectTypes": "No subject types",
    "sourceUrl": "Source URL",
    "searchTerms": "Search terms",
    "usageCount": "Usages",
    "isVisible": "Visible",
    "isFree": "Free",
    "isVerified": "Verified",
    "premium": "Premium partner",
    "premiumPartner": "Premium Partner",
    "deleteConfirm": "Do you really want to delete the entry \"{name}\"?",
    "import": "Import from catalogue",
    "importConfirm": "The material catalogue will be imported / refreshed. Continue?",
    "importSuccess": "{total} materials imported.",
    "classify": "Start classification",
    "classifyConfirm": "All materials' subject types will be reassigned from the catalogue. Continue?",
    "classifySuccess": "{total} materials classified.",
    "onlyWithoutTypes": "Only without type",
    "selectedCount": "{count} material selected | {count} materials selected"
  },
  "languages": {
    "columns": {
      "code": "Code",
      "isActive": "Active",
      "isUserSelectable": "Selectable by users",
      "name": "Name",
      "uiTranslations": "UI translations"
    },
    "create": "Add language",
    "deleteConfirm": {
      "description": "Do you really want to delete the language \"{language}\"? Languages that are already in use can only be deactivated.",
      "title": "Delete language"
    },
    "dialog": {
      "codeError": "The code must be a base language code of 2-3 lowercase letters (e.g. \"de\").",
      "codePlaceholder": "fr",
      "createTitle": "Add language",
      "editTitle": "Edit language",
      "namePlaceholder": "Français",
      "userSelectableHint": "Languages selectable by users appear in the language pickers. If UI translations are missing, texts fall back to the default language."
    },
    "title": "Languages"
  },
  "legalNotice": {
    "title": "Legal notice"
  },
  "loginProvider": {
    "apple": "Apple",
    "bildungsportal": "Bildungsportal",
    "google": "Google",
    "local": "Email"
  },
  "mobileBlocker": {
    "ctaButton": "Continue in browser anyway",
    "description": "Digidoo already works in the browser.<br>For the best overview and experience, we recommend a laptop or tablet.<br>The mobile version is currently being optimized.",
    "title": "Best to start on a laptop or tablet."
  },
  "multiCompetenceObservation": {
    "applyAll": "Apply to all",
    "applyAllDescriotionsSuccess": "Note applied to {count} {entity}",
    "applyCompetenceObservationToAll": "Apply assessment to all",
    "toggleObservationTypeByCompetence": "By competence",
    "toggleObservationTypeByStudent": "By student"
  },
  "myAccount": {
    "backToOrganisation": "Back to {organisation}",
    "deactivateAccount": {
      "accountConfirm": {
        "confirm": "Delete account",
        "description": "Please enter your first and last name to permanently delete your account.",
        "hint": "Deleting your account cannot be undone. All content will be permanently deleted after 14 days.",
        "namePlaceholder": "First and last name",
        "title": "Delete account"
      },
      "button": "Delete account",
      "feedback": {
        "description": "We’re sorry that Digidoo hasn’t won you over yet. What can we improve?",
        "error": "Your feedback could not be sent. Please try again or continue without feedback.",
        "placeholder": "Do you have any feedback?",
        "sending": "Sending …",
        "skip": "Continue without feedback",
        "title": "Sorry to see you go."
      },
      "ownerWarning": {
        "deleteSchool": "Delete school | Delete schools",
        "description": "You lead {schools}, so you cannot delete your account. You can transfer leadership to another member or delete the school. | You lead {schools}, so you cannot delete your account. You can transfer leadership to other members or delete the schools.",
        "subscriptionInfo": "If you delete your school, all active subscriptions will be cancelled automatically. | If you delete your schools, all active subscriptions will be cancelled automatically.",
        "title": "Delete account",
        "transferLeadership": "Transfer leadership"
      },
      "schoolDeleteConfirm": {
        "confirm": "Delete school | Delete schools",
        "description": "Please enter your first and last name to permanently delete the school {schools}. | Please enter your first and last name to permanently delete the schools {schools}.",
        "hint": "Deleting a school cannot be undone. All content will be permanently deleted after 14 days. Download anything you want to keep beforehand, such as reports.",
        "namePlaceholder": "First and last name",
        "success": "School deleted successfully | Schools deleted successfully",
        "title": "Delete school | Delete schools"
      }
    },
    "disabledSSOInfo": "Users who sign in with SSO via Google etc. can’t change their email or password. Please contact support if this is necessary.",
    "form": {
      "changeEmail": "Change email",
      "changeEmailHint": "After clicking \"Done\", you will receive an email to confirm your new email address.",
      "changeEmailSuccess": "The email was changed successfully.",
      "changeEmailSuccessInquiry": "We've sent you an email to confirm your new email address. Please check your inbox.",
      "changePassword": "Change password",
      "changePasswordSuccess": "Password changed successfully.",
      "currentPassword": "Current password",
      "deactivateAccount": "Deactivate account",
      "newMail": "New email"
    },
    "introduction": "Hi {firstName},",
    "introductionSubline": "Here you can manage your Digidoo account.",
    "rate": "Rate",
    "recommend": "Recommend",
    "sections": {
      "display": {
        "description": "This setting applies to how names are shown in lists, classes, and reports.",
        "nameOrderQuestion": "How do you want to see names in Digidoo?",
        "sortedBy": "Sorted by",
        "title": "Display",
        "updated": "Display settings updated",
        "weekRepresentation": {
          "calendarWeek": "Calendar weeks (e.g. CW39)",
          "description": "Applies to History and all week views in Digidoo. School weeks count from the first school day of your school year.",
          "question": "Show weeks as",
          "schoolWeek": "School weeks (e.g. SW1)"
        }
      },
      "emailAndPassword": "Email & password",
      "emailsAndNotifications": {
        "newsletter": "Newsletter",
        "technicalOnly": "Technically required notifications",
        "title": "Emails & notifications",
        "updatedSetting": "Notification settings updated",
        "weeklyReport": "Weekly report"
      },
      "language": {
        "description": "Applies to the app, email, and all communication. Competences are excluded.",
        "label": "Display language",
        "title": "Language",
        "updated": "Language updated"
      },
      "subscription": {
        "description": {
          "member": "You are <span class='font-semibold'>{role}</span> of the school {schoolName}. The subscription is managed by your school. There are no costs for you.",
          "owner": {
            "active": "Click Manage subscription to view or change your subscription.",
            "subscriptionEnded": "Your subscription has expired. Click Manage subscription to reactivate your subscription.",
            "subscriptionEnding": "Your subscription ends in {days} days. Click Manage subscription to view or renew your subscription.",
            "trialEnded": "You can <span class='font-semibold text-success'>keep using Digidoo for free</span> to document competences. Everything that takes work off your hands - like reports, analyses and structured handovers - is part of the upgrade.",
            "trialing": "Your {trialDays}-day trial ends in {days} days. After that, you can keep using Digidoo with the free basic access. For full access to all Digidoo features, you'll need an active subscription.",
            "youAre": "You are the <span class='font-semibold'>{role}</span> of the school {schoolName}."
          }
        },
        "discountCodeFaq": "How do I redeem my discount code?",
        "manage": "Manage subscription",
        "title": "Subscription status {schoolName}"
      },
      "twoFactorAuth": {
        "description": "With two-factor authentication (2FA), you can secure your Digidoo account even better – either via app or email. <span class='font-semibold'>This keeps your account optimally protected.<span>",
        "disableTooltipText": "You can no longer disable 2FA because you're a member of a school where 2FA is mandatory.",
        "title": "Two-factor authentication"
      }
    },
    "socialMedia": {
      "facebook": "Follow us on Facebook",
      "instagram": "Follow us on Instagram",
      "whatsapp": "Join our WhatsApp community"
    },
    "title": "My account",
    "toOnboarding": "Set up school"
  },
  "navigation": {
    "class": {
      "class": "Class",
      "reports": "Reports",
      "settings": "Settings",
      "statistics": "Analysis"
    },
    "provider": {
      "apiTokens": "API tokens",
      "competenceAssessments": "Competence assessment",
      "competenceTemplates": "Templates",
      "dashboard": "Dashboard",
      "feedback": "Feedback",
      "gradeScales": "Grades",
      "importCompetenceTemplates": "Import",
      "jobs": "Queue",
      "languages": "Languages",
      "onboardingCheckout": "Onboarding purchases",
      "releases": "Releases",
      "schoolYears": "School years",
      "schools": "Schools",
      "sso": "SSO",
      "tenants": "Tenants",
      "users": "Users",
      "masterData": "Master data",
      "system": "System",
      "home": "Home",
      "statistics": "Statistics",
      "monitoring": "Monitoring",
      "cron": "Cronjobs"
    }
  },
  "note": {
    "addAnnotationsPlaceholder": "Click here to add notes …",
    "addNotesPlaceholder": "Click here to add notes…",
    "delete": "Delete note",
    "deleteConfirm": {
      "confirmButtonLabel": "Delete",
      "declineButtonLabel": "Cancel",
      "description": "The note will be deleted permanently. This cannot be undone.",
      "title": "Delete note?"
    },
    "edit": "Edit note",
    "linkCompetence": "Link competence",
    "notes": "Notes",
    "title": "Note"
  },
  "notification": {
    "cannotOpen": "This notification couldn't be opened.",
    "noNotifications": "No new notifications",
    "title": "Notifications"
  },
  "onboarding": {
    "acquisitionSource": {
      "options": {
        "colleagueReferral": "Referral from colleagues",
        "eventTraining": "Event / Training",
        "googleSearch": "Google / Search",
        "other": "Other",
        "schoolAdmin": "School / Administration",
        "socialMedia": "Social media"
      },
      "title": "How did you hear about Digidoo?"
    },
    "checkout": {
      "billedPerStudents": "Billed per student",
      "billedPerTeachers": "Billed per teacher",
      "buyNow": "Buy now",
      "contactSupport": "Contact support",
      "finalizing": "Setting up your school …",
      "orPayWithCard": "or pay with card",
      "payment": {
        "failed": "The payment could not be completed. Please try again.",
        "processing": "Your payment is being processed – one moment …",
        "sessionFailed": "The purchase could not be started. Please try again.",
        "unavailable": "Payment is currently unavailable. Please try again later."
      },
      "perStudentPerYear": "per student per year",
      "perTeacherPerMonth": "per teacher per month",
      "priceChanged": "The price has been updated. Please review the order summary and click “Buy now” again.",
      "priceFrom": "from {price}",
      "promotionChip": "🍁 Autumn special",
      "provisioningFailed": "Your payment succeeded, but setting up your school is taking a little longer. We're handling it automatically – please contact support if the problem persists.",
      "studentQuantityLabel": "Number of students",
      "summary": {
        "expressDiscount": "Express discount",
        "studentsLine": "Students",
        "teachersLine": "Teachers",
        "teachersLineUnitPrice": "at {unitPrice} each",
        "tierFrom": "from {from} students",
        "tierPrices": "Tiered prices",
        "total": "Total",
        "unlimitedStudents": "Unlimited students",
        "unlimitedTeachers": "Unlimited teachers",
        "vat": "{percent}% VAT"
      },
      "supportMail": {
        "body": "Hello Digidoo team,\n\nmy payment succeeded, but my school has not been set up yet.\n\nCheckout reference: {draftId}\n\nBest regards",
        "subject": "Problem completing my purchase – school was not set up"
      },
      "teacherQuantityLabel": "Number of teachers",
      "title": "Secure {discount}\non your first year now!",
      "titleDiscount": "{percent} % off",
      "trialButton": "Try for free",
      "trialLink": "or try for free"
    },
    "class": {
      "hasNickname": "Does your class have a nickname?",
      "name": "Name",
      "schoolLevel": "School level",
      "title": "Hi {firstName}, let's set up your class together."
    },
    "createSchool": {
      "description": "With a few details, we can tailor Digidoo to your needs.",
      "title": "Set up Digidoo for your lessons."
    },
    "finalize": {
      "helpText": "We hope you enjoy Digidoo, and please let us know anytime how we can keep improving Digidoo for you.",
      "letsGo": "Let's go!",
      "titleAdmin": "Great, you're now ready to get started.\nWe hope you enjoy Digidoo",
      "titleClassic": "Great, you're now ready to get started.",
      "titlePersonalClass": "Great to have you here {firstName}. You’ve already been assigned a class, let’s go!",
      "titlePersonalDemoOnlyClass": "Great to have you here {firstName}. You don’t have a regular class yet, but you can already try Digidoo in the demo class.",
      "titlePersonalNoClass": "Great to have you here {firstName}. You haven’t been assigned a class yet. We’ll let you know as soon as you can get started.",
      "titlePersonalPrimary": "Great to have you here {firstName}.",
      "titlePersonalSecondaryAdmin": "As an administrator, you have access to all classes in the school and can change settings.",
      "titlePersonalSecondaryClass": "You’ve already been assigned a class, let’s go!",
      "titlePersonalSecondaryDemoOnlyClass": "You don’t have a regular class yet, but you can already try Digidoo in the demo class.",
      "titlePersonalSecondaryGroup": "You’ve already been assigned a group, let’s go!",
      "titlePersonalSecondaryNoClass": "You haven’t been assigned a class yet. We’ll let you know as soon as you can get started."
    },
    "finalizeBilling": {
      "titlePrimary": "Great to have you here {firstName} 😊",
      "titleSecondary": "Digidoo supports long-term learning development, makes strengths and progress visible, and creates reports at the click of a button.",
      "trialHint": "Test all features – then keep using Digidoo for free."
    },
    "success": {
      "body": "Whether alone or in a team – Digidoo makes learning progress visible and creates reports at the click of a button.",
      "continue": "Let's go",
      "purchase": {
        "titlePrimary": "Yay, you're ready to go!",
        "titleSecondary": "Your {planTitle} plan is active. Let's go 🎉",
        "titleSecondaryNoPlan": "Your plan is active. Let's go 🎉"
      },
      "trial": {
        "buyNow": "Buy now instead?",
        "buyNowPromotion": "Secure {percent}% autumn discount",
        "titlePrimary": "Yay, you're ready to go!",
        "titleSecondary": "Digidoo is now fully unlocked for you. 🎉"
      }
    },
    "footer": {
      "logout": "Logout"
    },
    "joinSchool": {
      "hint": "How do I get my access code?",
      "subtitle": "To join an existing school, click your invitation link or enter your one-time access code.",
      "title": "Join an existing school."
    },
    "profile": {
      "title": "Let's get to know each other first.",
      "whichSchool": "Which school do you teach at?",
      "whichSchoolPlaceholder": "Example Primary School"
    },
    "school": {
      "canton": "Canton",
      "country": "Country",
      "enterData": "Enter data manually",
      "nameLabel": "Search for your school",
      "namePlaceholder": "School name, school ID, etc.",
      "noSchoolHintText": "e.g. for private organizations, private tutors, parents etc.",
      "noSchools": "No school found for \"{query}\"",
      "noSchoolsHelp": "Can't find your school?",
      "noSchoolsHelpContact": "Contact us",
      "ownSchoolType": "Custom school type",
      "ownSchoolTypeLabel": "Custom school type",
      "proceedWithoutSchool": "Continue without selecting a school",
      "schoolAlreadyInUseconfirmDialog": {
        "confirmButtonLabel": "Join existing school",
        "declineButtonLabel": "Create school anyway",
        "description": "The school “{schoolName}” is already active on Digidoo. Please contact the school principal to join the team.",
        "title": "School already exists"
      },
      "schoolHasNoSchoolType": "There are no competence templates available for this school type yet. But you can create and customize your own templates at any time.",
      "schoolIsAlreadyUsed": "This school is already active on Digidoo. You can still continue and create a separate, independent school instance.",
      "schoolType": "School type",
      "searchSchool": "Search for school",
      "slogan": "School motto",
      "sloganPlaceholder": "The healthy primary school",
      "state": "State"
    },
    "schoolLevels": {
      "edit": "Edit school levels",
      "editConfirmDescription": "Please enter your first and last name or your email address to edit the school levels.",
      "editConfirmHint": "The removed school levels will also be removed from your school's competence templates. Existing classes are not affected.",
      "editDescription": "Which school levels does your school cover?",
      "primary": "Primary level",
      "secondary": "Secondary level",
      "title": "Now please select the school levels for your “{schoolTypeName}”."
    },
    "schoolSubject": {
      "helpText": "You can adjust all competences later and add new ones.",
      "importOwnCompetences": "Import your own competences",
      "title": "Great, we've already prepared all competences for school level {schoolLevel} for you."
    },
    "selection": {
      "title": "Hi {firstName},\nHow would you like to use Digidoo?"
    },
    "students": {
      "addStudent": "Add another student",
      "addStudentOptional": "Or enter new students",
      "helpText": "You can still adjust the students later.",
      "title": "Would you like to enter your list of students right away?",
      "validationError": "Every student must have a first and last name."
    },
    "team": {
      "helpText": "You can invite several people at once. Just enter multiple email addresses, separated by commas.",
      "mailsPlaceholder": "firstname.lastname{'@'}school.at",
      "messagePlaceholder": "Optional message",
      "title": "Now invite your team via email."
    },
    "waitingApproval": {
      "approvalHint": "We'll be in touch by email shortly, as soon as your school has been approved.",
      "subline": "At Digidoo, every school is onboarded individually – this takes us a little time.",
      "title": "Hi {firstName},",
      "videoButton": "Watch intro video",
      "videoHint": "In the meantime, you can already discover what's in store for you in our intro video."
    }
  },
  "onboardingCheckoutCases": {
    "columns": {
      "buyer": "Buyer",
      "lastError": "Last error",
      "plan": "Plan",
      "school": "School",
      "status": "Status",
      "updatedAt": "Last updated"
    },
    "discard": "Discard",
    "discardConfirm": {
      "description": "Really discard the checkout draft for “{school}”? An unpaid payment attempt will be canceled.",
      "title": "Discard checkout draft?"
    },
    "openStripeCustomer": "Open Stripe customer",
    "openStripeSubscription": "Open Stripe subscription",
    "openTenant": "Open school",
    "provision": "Provision now",
    "status": {
      "pendingPayment": "Awaiting payment",
      "provisioned": "Paid & created",
      "provisioningFailed": "Creation failed"
    },
    "statusFilterAll": "All statuses",
    "title": "Onboarding purchases"
  },
  "pdfPrint": {
    "competence": "Competence",
    "page": "Page {page}",
    "pageOf": "{current} of {total}",
    "studentName": "Child's name"
  },
  "performanceAssessment": {
    "addNotes": "Add note",
    "addSubjectSpecific": "Add subject-specific performance assessments",
    "changeSymbol": "Change symbol for {name}",
    "confirm": "Entries already exist for this performance assessment. Are you sure you want to edit it?",
    "copyTo": "Copy to…",
    "count": "Performance assessment {count}",
    "countAlt": "{count} performance assessment | {count} performance assessments",
    "create": "New performance assessment",
    "createOwn": "Custom performance assessment",
    "edit": "Edit performance assessment",
    "editList": "Edit list",
    "editPlural": "Edit performance assessments",
    "emptyStateDescription": "Create your first performance assessment now.",
    "emptyStateTitle": "No performance assessments yet",
    "hasObservationWarning": "This performance assessment has already been used. Changes are therefore limited.",
    "helpText": "You can also adjust the performance assessments later.",
    "hint": "Here you define how performance is documented for each school level and semester. A template is already available for competence tracking.",
    "noPAsYetForSubject": "You haven't created any performance assessments for this subject yet.",
    "noWeighting": "No weighting",
    "noWeightingLabel": "None",
    "remove": "Delete performance assessment",
    "removeConfirmText": "Are you sure you want to delete the performance assessment \"{name}\"?",
    "removeSubjectSpecific": "Remove subject-specific performance assessments",
    "removeSubjectSpecificDescription": "The {count} entries linked to this performance assessment will be deleted. This cannot be undone. The performance assessments for all subjects will then be used again.",
    "removeSubjectSpecificDescriptionEmpty": "The subject-specific performance assessments will be deleted. This cannot be undone. The performance assessments for all subjects will then be used again.",
    "removeSubjectSpecificDescriptionOneEntry": "The entry linked to this performance assessment will be deleted. This cannot be undone. The performance assessments for all subjects will then be used again.",
    "removeSubjectSpecificNamePlaceholder": "Enter your name to confirm",
    "removeSubjectSpecificTitle": "Remove custom performance assessments for {subject}?",
    "removeTitle": "Remove {name}?",
    "removeWithEntriesConfirmText": "All {count} entries linked to this performance assessment will be deleted. This cannot be undone.",
    "removeWithEntriesNamePlaceholder": "Enter your name to confirm",
    "removeWithOneEntryConfirmText": "The entry linked to this performance assessment will be deleted. This cannot be undone.",
    "schoolTemplate": "School template",
    "subjectSearchPlaceholder": "Search for a subject…",
    "subjectSpecificSetupCopyAction": "Create",
    "subjectSpecificSetupCopyDescription": "The general performance assessments will be carried over to {subject} with {count} linked entries. They will then be managed independently and cannot be merged back together.",
    "subjectSpecificSetupCopyDescriptionOneEntry": "The general performance assessments will be carried over to {subject} with one linked entry. They will then be managed independently and cannot be merged back together.",
    "subjectSpecificSetupCopySuccess": "The performance assessments for {subject} were carried over.",
    "subjectSpecificSetupCopyTitle": "Create performance assessments for {subject}?",
    "template": "Template",
    "templates": "Templates",
    "tipTeacher": "Here you can see which type of performance documentation is used in your class <b>{currentClass}</b>. Depending on your permissions, you can edit it or add new documentation types.",
    "title": "Performance assessments",
    "weighting": "Weighting"
  },
  "performanceAssessmentEntry": {
    "addNotes": "Add note",
    "applyObservationToAll": "Apply to all",
    "collectiveAssessment": {
      "apply": "Apply to all",
      "button": "Collective assessment",
      "competenceLabel": "Competence",
      "hint": "Tap a tile and the assessment will be applied to all students.",
      "ratingLabel": "Assessment",
      "targetCompetences": "Competences",
      "targetLabel": "Assessment type",
      "targetPerformanceAssessment": "Performance assessment",
      "title": "Collective assessment",
      "unknownCompetence": "Competence #{id}"
    },
    "competencesDescription": "Do you want to add competences to this performance assessment?",
    "competencesHelpText": "You can also create the performance assessment without competences.",
    "confirmBulkDescriptionDialog": {
      "fullyDescribed": {
        "confirm": "Overwrite all",
        "description": "All selected students already have observations. Should they be overwritten?"
      },
      "partiallyDescribed": {
        "confirm": "Overwrite all",
        "decline": "Fill missing",
        "description": "Some students already have observations. Should they be overwritten, or do you want to fill in only missing ones?"
      },
      "title": "Observations already exist"
    },
    "confirmBulkDialog": {
      "fullyObserved": {
        "confirm": "Overwrite all",
        "description": "All selected students already have assessments. Should they be overwritten?"
      },
      "partiallyObserved": {
        "confirm": "Overwrite all",
        "decline": "Fill missing",
        "description": "Some students already have assessments. Should they be overwritten, or do you want to fill in only missing ones?"
      },
      "title": "Assessments already exist"
    },
    "confirmContinueWithoutCompetences": {
      "confirmButtonLabel": "Select competence",
      "declineButtonLabel": "Create annotation only",
      "description": "No competence was selected for this entry. The entry will therefore only be saved as an annotation.",
      "title": "No competence selected"
    },
    "confirmDuplicateGradings": {
      "confirmButtonLabel": "Carry over ratings",
      "declineButtonLabel": "Do not carry over",
      "description": "Do you want to carry over the existing ratings and notes for this learning progress?",
      "title": "Carry over ratings"
    },
    "confirmDuplicateSingle": {
      "confirmButtonLabel": "Duplicate for all",
      "declineButtonLabel": "Only for {studentName}",
      "description": "This entry includes other students. Should the entry be duplicated for everyone or only for {studentName}?",
      "title": "Duplicate entry"
    },
    "description": "Note for performance assessment (optional)",
    "detailDialog": {
      "confirmDelete": {
        "description": "The performance assessment and all associated ratings and observations will be permanently deleted. This cannot be undone.",
        "title": "Delete performance assessment?"
      },
      "confirmRemoveCompetence": {
        "description": "The competence will be removed from this performance assessment. Any ratings already recorded for this competence will be permanently deleted.",
        "title": "Remove competence?"
      },
      "confirmRemoveStudents": {
        "description": "The deselected students will be removed from this performance assessment. Their existing ratings and observations will be permanently deleted.",
        "title": "Remove students?"
      },
      "linkedCompetences": "Linked competences",
      "nextStudent": "Next student",
      "noteAvailable": "Observation available",
      "openStudentList": "Open student list",
      "previousStudent": "Previous student"
    },
    "documentation": "Documentation",
    "editCompetenceGrid": "Edit competence grid",
    "editEntry": "Edit performance assessment",
    "emptyStateDescription": "Create an entry now.",
    "filteredEmptyStateDescription": "No entries match the current search.",
    "filteredEmptyStateTitle": "No matching entries",
    "linkedCompetences": "Linked competences",
    "metaData": "Please select the subject and type of performance assessment.",
    "newEntry": "New learning progress",
    "noLinkedCompetences": "No linked competences",
    "noStudentsAddCta": "Add students",
    "noStudentsEmptyStateTitle": "No students in this class yet",
    "noStudentsRequestCta": "Request students",
    "noStudentsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for class \"{className}\", but there are no students linked to this class yet and I do not have permission to add them myself.\n\nPlease add or link students for this class so I can start working:\n{classStudentsLink}\n\nThank you!",
    "noStudentsRequestMailSubject": "Please add students for class \"{className}\"",
    "noSubjectsYet": "You haven't created any subjects yet. First create a subject in the competence grid to create learning progress entries.",
    "notes": "Note for performance assessment",
    "open": "Open",
    "pdf": {
      "confirmButton": "Download",
      "confirmDescription": "Do you really want to download this learning progress?",
      "confirmTitle": "Download learning progress",
      "generationFailed": "PDF generation failed. Please try again."
    },
    "performanceAssessmentType": "Type",
    "ratingLabel": "Rating",
    "students": "{count} student | {count} students",
    "studentsDescription": "Select the students for the performance assessment.",
    "studentsHelpText": "You can also add students later.",
    "subject": "Subject",
    "timelineSetup": {
      "noStudentSubjectsCreateCta": "Link subjects",
      "noStudentSubjectsMessage": "This student needs a subject. Link a subject first.",
      "noStudentSubjectsRequestCta": "Request subjects",
      "noStudentSubjectsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for {studentName} in class \"{className}\", but no subjects are linked for this student yet and I do not have permission to add them myself.\n\nPlease link subjects for this student so I can start working:\n{classSetupLink}\n\nThank you!",
      "noStudentSubjectsRequestMailSubject": "Please link subjects for {studentName} in class \"{className}\"",
      "noStudentSubjectsTitle": "No subjects linked yet",
      "noStudentsCreateCta": "Add students",
      "noStudentsMessage": "Learning progress entries need students. Add them first or link existing students to this class.",
      "noStudentsRequestCta": "Request students",
      "noStudentsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for class \"{className}\", but there are no students linked to this class yet and I do not have permission to add them myself.\n\nPlease add or link students for this class so I can start working:\n{classSetupLink}\n\nThank you!",
      "noStudentsRequestMailSubject": "Please add students for class \"{className}\"",
      "noStudentsTitle": "No students yet",
      "noSubjectsCreateCta": "Add subjects",
      "noSubjectsMessage": "Each learning progress entry needs a subject. Add subjects for this class first.",
      "noSubjectsRequestCta": "Request subjects",
      "noSubjectsRequestMailBody": "Hi {firstNameReceiver},\n\nI would like to create learning progress entries for class \"{className}\", but there are no subjects set up for this class yet and I do not have permission to add them myself.\n\nPlease add subjects for this class so I can start working:\n{classSetupLink}\n\nThank you!",
      "noSubjectsRequestMailSubject": "Please add subjects for class \"{className}\"",
      "noSubjectsTitle": "No subjects yet"
    },
    "unratedLabel": "Not yet rated"
  },
  "performanceAssessmentStudentEntry": "Performance entry for student",
  "performanceVisual": {
    "assessmentSteps": "Assessment levels",
    "bad": "poor",
    "blockedByAccessRights": "You can't change the visualization because you don't have permission for this action.",
    "blockedByClassArchived": "You can't change the visualization because the class is archived.",
    "blockedByEntries": "You can't change the visualization because entries have already been made.",
    "create": "New visualization",
    "createOwn": "Custom visualization",
    "edit": "Edit visualization",
    "good": "good",
    "isLinkedToPerformanceAssessmentWarning": "This visualization is linked to a performance assessment. Changes are therefore limited.",
    "nonOfficial": "Custom",
    "official": "Digidoo templates",
    "steps": "{ name } ({ count } level) | { name } ({ count } levels)",
    "stepsAlt": "{ count } level | { count } levels",
    "tipAdmin": "Here you can upload your own visualizations for your <b>{school}</b> and also get a selection of common templates ready to use.",
    "tipTeacher": "Here you can see the visualizations used for performance documentation in your class <b>{currentClass}</b>. Depending on your permissions, you can add more visualizations.",
    "visual": "Visualization"
  },
  "privacy": {
    "title": "Privacy"
  },
  "providerDashboard": {
    "acquisitionSource": {
      "colleagueReferral": "Referral",
      "eventTraining": "Event",
      "googleSearch": "Google / Search",
      "other": "Other",
      "schoolAdmin": "School / Administration",
      "socialMedia": "Social media",
      "title": "Acquisition sources"
    },
    "competenceTemplates": {
      "title": "Competence templates"
    },
    "entryActivity": {
      "observations": "Observations",
      "performanceEntries": "Assessment entries",
      "resolution": {
        "day": "Day",
        "month": "Month",
        "week": "Week"
      },
      "resolutionPicker": "Select resolution",
      "title": "Entry activity",
      "totalEntries": "{formattedCount} entry | {formattedCount} entries"
    },
    "filter": {
      "admin": "Admin",
      "allCountries": "All countries",
      "allRoles": "All roles",
      "days": "{count} days",
      "owner": "Owner",
      "user": "User"
    },
    "interval": "Interval: ",
    "kpi": {
      "classesAndGroups": "Classes / Groups",
      "observations": "Observations",
      "performanceAssessments": "Assessments",
      "reports": "Reports",
      "students": "Students",
      "tenants": "Schools",
      "twoFactor": "2FA active",
      "users": "Users"
    },
    "menuTitle": "Dashboard",
    "newUsers": {
      "resolutionPicker": "Select resolution",
      "title": "New users",
      "totalUsers": "{formattedCount} user | {formattedCount} users"
    },
    "loginProviderDistribution": {
      "title": "Login provider distribution"
    },
    "onboardingFunnel": {
      "account_created": "Account created",
      "administration_setup_done": "Administration setup",
      "class_created": "Class created",
      "email_verified": "Email verified",
      "first_entry_created": "First entry",
      "fromPreviousStep": "from prev. step",
      "license_purchased": "Subscription purchased",
      "mode": {
        "closed": "Closed",
        "open": "Open"
      },
      "modeInfo": "<b>Closed:</b> Each step requires all previous steps to be completed. Counts are cumulative and always decrease.<br/><br/><b>Open:</b> Each step is counted independently, regardless of whether previous steps were completed.",
      "modeLabel": "Mode",
      "modePicker": "Funnel mode",
      "school_created": "School created",
      "title": "Owner onboarding funnel"
    },
    "productStatus": {
      "activeProduct": "Active subscription",
      "downgraded": "Free version",
      "expired": "Trial ended",
      "freeTrial": "Trial",
      "noProduct": "No subscription",
      "title": "Subscription status"
    },
    "productType": {
      "proUser": "One",
      "school": "Team",
      "team": "Flex",
      "title": "Product distribution"
    },
    "reportDistribution": {
      "competenceType": "Competence type distribution",
      "coverSheet": "Cover sheet distribution",
      "none": "None",
      "summarySheet": "Summary sheet distribution"
    },
    "roleDistribution": {
      "title": "Role distribution"
    },
    "schoolTypeDistribution": {
      "selectCountry": "Select a country to see the school type distribution.",
      "title": "School type distribution"
    },
    "starRating": {
      "averageRating": "Average",
      "title": "Star ratings"
    },
    "tenantLocationDistribution": {
      "cantons": "Canton distribution",
      "countries": "Country distribution",
      "emptyDescription": "No schools with a matching country or state assignment were found for the selected filters.",
      "emptyTitle": "No schools found",
      "states": "State distribution"
    },
    "timelineActivity": {
      "notes": "Notes",
      "performanceAssessmentEntries": "Performance assessments",
      "resolutionPicker": "Select resolution",
      "supportMeasureEntries": "Support measures",
      "totalSupportMeasureEntries": "{formattedCount} support measure | {formattedCount} support measures",
      "typeDistribution": "Timeline: entry type distribution"
    },
    "trialExpiredFeedback": {
      "missingFeatures": "Missing features",
      "preferFreeVersion": "Prefers staying free",
      "subscriptionTooExpensive": "Too expensive",
      "title": "Feedback: Trial expired",
      "underUsed": "Underused"
    },
    "usage": {
      "classesAndPerformance": "Classes & assessments",
      "classesOnly": "Classes only",
      "hasEntries": "Has entries",
      "performanceOnly": "Assessments only",
      "title": "Usage"
    },
    "userActivity": {
      "active": "Active",
      "hasEntities": "Has entries",
      "highlyActive": "Highly active",
      "inactive": "Inactive",
      "setupIncomplete": "Setup incomplete",
      "title": "User activity"
    }
  },
  "providerCron": {
    "title": "Cronjobs",
    "detail": {
      "title": "Cronjob details"
    },
    "refresh": "Refresh",
    "filters": {
      "name": "Cronjob",
      "status": "Status",
      "allNames": "All cronjobs",
      "allStatuses": "All statuses"
    },
    "table": {
      "name": "Cronjob",
      "schedule": "Schedule",
      "lastStarted": "Last started",
      "lastSucceeded": "Last succeeded",
      "lastFailed": "Last failed",
      "error": "Error message"
    },
    "status": {
      "ok": "OK",
      "failed": "Failed",
      "running": "Running",
      "never-run": "Never run"
    },
    "names": {
      "attribution-cleanup": "Attribution data cleanup",
      "attribution-conversion-delivery": "Report purchases to ad platforms",
      "billing-sync": "Billing sync",
      "billing-referral-reconciliation": "Referral reconciliation",
      "billing-onboarding-draft-sweep": "Onboarding purchases cleanup",
      "billing-trial-ending-mail": "Trial ending – email",
      "billing-trial-ended-mail": "Trial ended – email",
      "billing-offer-expiry-reminder-mail": "Offer expiring – email",
      "two-factor-reminder-mail": "2FA reminder – email",
      "onboarding-reminder-mail": "Onboarding reminder – email",
      "growth-trial-mails": "Growth trial emails",
      "weekly-report-emails": "Weekly report – emails",
      "deactivated-account-cleanup": "Deactivated account cleanup",
      "crm-contact-sync": "CRM contact sync",
      "session-cleanup": "Session cleanup",
      "subject-classification": "Subject classification",
      "support-account-cleanup": "Support account cleanup"
    }
  },
  "providerJobs": {
    "count": "{visible} of {total}",
    "detail": {
      "executeNow": "Execute now",
      "executeNowConfirmDescription": "The job will be rescheduled for immediate execution.",
      "executeNowConfirmTitle": "Execute job now?",
      "title": "Job details"
    },
    "failedTitle": "Failed jobs",
    "historyTitle": "Execution history",
    "outcome": {
      "cancelled": "Cancelled",
      "completed": "Completed",
      "failed": "Failed"
    },
    "priority": {
      "high": "High",
      "low": "Low",
      "normal": "Normal"
    },
    "queuedTitle": "Queued and running jobs",
    "refresh": "Refresh",
    "reset": {
      "confirm": "Reset queue",
      "description": "All queued, scheduled, retrying, and permanently failed jobs will be removed. Running jobs will continue.",
      "success": "Removed {removed} jobs. {running} running jobs were left untouched.",
      "title": "Reset queue?"
    },
    "stats": {
      "execution": "Average execution time",
      "pickup": "Average pickup time",
      "total": "Average total time"
    },
    "status": {
      "failed": "Failed",
      "queued": "Queued",
      "retrying": "Retrying",
      "running": "Running",
      "scheduled": "Scheduled"
    },
    "table": {
      "attempts": "Attempts",
      "error": "Error",
      "executionDuration": "Execution time",
      "finishedAt": "Finished at",
      "graphileJobId": "Graphile job ID",
      "job": "Job",
      "operationUuid": "Operation UUID",
      "payload": "Payload",
      "pickupDuration": "Pickup time",
      "priority": "Priority",
      "queue": "Queue",
      "queuedAt": "Queued at",
      "result": "Result",
      "scheduledAt": "Scheduled at",
      "startedAt": "Started at",
      "totalDuration": "Total time"
    },
    "title": "Queue"
  },
  "providerTemplates": {
    "visualsTip": "The pictograms used to rate performance (colours, smileys, grade numbers …). They come from a fixed app catalogue and are read-only here — the other templates reference them per country. Adding a new visual requires a developer.",
    "performanceAssessmentsTip": "The gradable activity types (participation, test, exam …), defined per school level and subject. Names are localised per content language and each links to a visual; a country- or language-specific entry overrides the global default.",
    "gradeScalesTip": "One scale per country (and content language) defines the grade levels and which end is the best grade. Set the direction and edit the level names — a tenant inherits its country's scale. There is always exactly one per scope; it cannot be deleted.",
    "competenceTip": "Global and fixed: exactly one per school level, where you only choose the visual used to rate competence entries. The label is translated by the app and the entry always exists — it cannot be deleted.",
    "schoolTypeConfigTip": "Define which school levels each school type covers and how they are labelled (raw numbering vs. adjusted), per country — with optional state or language overrides. This drives the levels available to a tenant of that school type.",
    "templateSetsTip": "Template sets are the curricula (subjects + competences) a tenant starts with, scoped by country, content language and school type. A tenant copies the most-specific matching set when it is created."
  },
  "quickEntry": {
    "clearCompetences": "Remove competences",
    "collapsedPlaceholder": "What would you like to capture?",
    "collectiveRatingStudents": "Collective rating for {students}",
    "collectiveRatingWholeClass": "Collective rating for the whole class",
    "commandCompetences": "Competences",
    "commandOpenSubject": "Subject…",
    "commandOpenCompetences": "Competences…",
    "commandOpenStudents": "Students…",
    "commandSubject": "Subject",
    "confirmDiscard": {
      "confirmButtonLabel": "Discard",
      "declineButtonLabel": "Keep editing",
      "description": "Your quick entry has not been saved yet. Do you want to discard it?",
      "title": "Discard entry?"
    },
    "createdToast": {
      "action": "Open"
    },
    "dialogLabel": "Quick entry",
    "expandLabel": "Start a quick entry",
    "rateIndividually": "Rate individually …",
    "removeSubject": "Remove subject",
    "requiredAction": {
      "performanceAssessment": "Select a performance assessment.",
      "schoolSubject": "Add a subject.",
      "students": "Select at least one student.",
      "text": "Add some text.",
      "textTooLong": "The text is too long. Please shorten it."
    },
    "saveEntry": "Save entry",
    "searchSubjectsPlaceholder": "Search subjects…",
    "sectionPerformanceAssessment": "Performance assessment",
    "selectionHint": "Type {personShortcut} for people or {commandShortcut} for subjects and competences — e.g. {personExample} or {subjectExample}",
    "selectionHintPersonExample": "{'@'}angelica",
    "selectionHintSubjectExample": "/german",
    "selectPerformanceAssessment": "Select performance assessment",
    "selectSubject": "Select subject",
    "typeNote": "Note",
    "typeSupportMeasure": "Support measure",
    "visibilityHint": {
      "missingCompetence": "The entry will be saved for {studentName}, but without a selected competence it will not appear in this timeline.",
      "missingStudent": "The entry will be saved, but without {studentName} it will not appear in this timeline."
    }
  },
  "referral": {
    "dialog": {
      "descriptionMember": "Share your personal referral link with colleagues. If someone takes out a Digidoo subscription through it, your school gets up to 50% off your own subscription.",
      "descriptionOwner": "Share your personal referral link with colleagues. If someone takes out a Digidoo subscription through it, you get up to 50% off your own subscription.",
      "linkCopied": "Referral link copied to clipboard",
      "myLink": "My referral link",
      "percentDiscount": "{percent}%",
      "rewardDescriptionMember": "Your school gets {discount} off the next Digidoo invoice.",
      "rewardDescriptionOwner": "You get {discount} off your next Digidoo invoice.",
      "rewardTitle": "You don't have any referrals yet. | Thank you for {count} successful referral. | Thank you for {count} successful referrals.",
      "sendLink": "Send link",
      "sendLinkEmailSubject": "My recommendation for you: Digidoo 🌼",
      "sendLinkEmailText": "Hey 👋\n\nI'm using Digidoo to document learning progress and competences in a structured way – and I can really recommend it.\nYou can also use it as a team or school-wide.\n\n👉 You can try it here for free:\n{ referralLink }\n\nBest,\n{ name }",
      "subtitleMember": "and your school gets up to 50% off the next invoice.",
      "subtitleOwner": "and get up to 50% off your next invoice.",
      "title": "Get up to 50% off."
    },
    "postReleaseDialog": {
      "description": "Digidoo grows through recommendations from teachers like you. If Digidoo helps you, we appreciate every recommendation.",
      "title": "Thanks for your support 💜"
    },
    "prompt": {
      "primary": "Recommend Digidoo",
      "secondary": "I'll do it later"
    },
    "reportSuccessDialog": {
      "description": "Help other teachers save time on documentation too.",
      "title": "Report created successfully 💜"
    },
    "widget": {
      "title": "Referral program"
    }
  },
  "release": {
    "actionTarget": {
      "gradeCalculationSettings": "Grade calculation (school settings)",
      "none": "– no action –"
    },
    "all": "Releases",
    "close": "Got it",
    "confirm": {
      "confirmButtonLabel": "Publish",
      "declineButtonLabel": "Cancel",
      "description": "Please confirm that you want to publish this release. This will send a notification to all users in the system. To do so, type 'Digidoo' into the field below.",
      "removeConfirmInputPlaceholder": "Digidoo",
      "title": "Publish release"
    },
    "confirmClose": {
      "confirmButtonLabel": "Close without saving",
      "description": "Do you really want to close this release? All changes made so far will be lost.",
      "title": "Close release"
    },
    "content": {
      "options": {
        "bulletPoint": "Bullet point",
        "image": "Image",
        "text": "Text",
        "title": "Title"
      },
      "title": "Content",
      "type": "Type"
    },
    "create": "Create release",
    "cta": {
      "description": "Optional button that takes users directly to a relevant setting. The button label is derived automatically from the selected target. Only shown to owners and administrators.",
      "labels": {
        "gradeCalculationSettings": "More about grade calculation"
      },
      "target": "Target",
      "title": "Action"
    },
    "identifier": "Identifier",
    "identifierDescription": "The identifier (e.g. 1.4.6) is shown in the notification message next to the text 'What's new in Digidoo {ID}', as well as in the dialog above the title.",
    "image": {
      "description": "Optional header image that is only shown in the release dialog above the content.",
      "title": "Banner image"
    },
    "releaseNow": "Publish now",
    "releasedAt": "Published",
    "success": "Release published successfully!",
    "testEmail": {
      "action": "Send test email",
      "description": "Select the users who should receive a test email for release {releaseId}.",
      "noRecipients": "No users selected yet.",
      "searchPlaceholder": "Search users",
      "send": "Send test email",
      "success": "Test email sent successfully!",
      "title": "Send test email"
    },
    "title": "Title",
    "titleDescription": "The title only appears as the heading in the dialog."
  },
  "reports": {
    "access": {
      "hasAccessDouble": "<b>You</b> and <b>{name1}</b> have access to this report.",
      "hasAccessMultiple": "<b>You</b>, <b>{name1}</b> and <b>{count}</b> other have access to this report. | <b>You</b>, <b>{name1}</b> and <b>{count}</b> others have access to this report.",
      "hasAccessSingle": "<b>You</b> have access to this report.",
      "hasAccessTriple": "<b>You</b>, <b>{name1}</b> and <b>{name2}</b> have access to this report."
    },
    "allReports": "All reports",
    "ambiguousCompetenceCount": "{count} ambiguous competence | {count} ambiguous competences",
    "commentPlaceholder": "Comments (optional)",
    "competencesSchoolLevel": "Competences for school level {schoolLevel}",
    "completeReport": "Complete report",
    "completedAt": "on {date} at {time}",
    "completedAtLong": "Completed on {date}",
    "completedBy": "by {name}",
    "configuration": {
      "assessedCompetencesOnly": "Only show documented competences in the report",
      "competenceTypeOptionDescription": {
        "compact": "All competences of all subjects are displayed in a compact, clear format on just a few pages.",
        "simple": "Shows one subject per page with competence domains and the competence flower for a quick overview.",
        "withNotes": "Shows competences with the competence flower and offers extra space for individual notes.",
        "withPerformanceAssessments": "Displays competences with the competence flower along with the related performance assessments."
      },
      "competenceTypeOptions": {
        "compact": "Compact",
        "simple": "Simple",
        "withNotes": "Notes",
        "withPerformanceAssessments": "Assessments"
      },
      "competences": "Report format",
      "coverSheet": "Cover sheet",
      "coverSheetOptions": {
        "simple": "Simple",
        "withChart": "Competence flower",
        "withCustomImage": "Own picture",
        "withFlower": "Flower",
        "withNote": "Note"
      },
      "description": "How would you like to design the report?",
      "notesReportDescription": "Lists all notes of the period in a table.",
      "showCompetenceLevelDescriptions": "Show competence level descriptions",
      "showGradeRecommendation": "Show grade recommendation",
      "showNoteCompetences": "Show linked competences",
      "summarySheet": "Signatures & notes",
      "summarySheetOptions": {
        "signature": "School signature",
        "simple": "Parent feedback"
      }
    },
    "confirmCloseDescription": "Once you complete the report, you can no longer make any changes.",
    "confirmCloseWithAmbiguousPerformanceLevels": "The report still contains {ambiguousCompetences}. Please review it before completing the report.|The report still contains {ambiguousCompetences}. Please review them before completing the report.",
    "confirmCloseWithAmbiguousPerformanceLevelsTitle": "Ambiguous competences",
    "coverImage": {
      "changeLayout": "Change layout",
      "errorSize": "The file is too large. A maximum of 1 MB is allowed.",
      "errorType": "This file type is not supported. Allowed types are PNG, JPG or WebP.",
      "hint": "{types} · max. {size}",
      "options": "Options",
      "remove": "Remove",
      "replace": "Replace",
      "requiredDescription": "The “Own picture” cover sheet needs a picture. Upload one or choose a different cover sheet layout to complete the report.",
      "requiredTitle": "Own picture missing",
      "upload": "Upload picture",
      "uploading": "Uploading..."
    },
    "create": "New report",
    "createNotesReport": "New notes report",
    "creatingReports": "Reports are being created…",
    "delete": "Delete report",
    "deleteConfirmDescription": "Do you really want to delete this report and all its pages? This action cannot be undone.",
    "deleteGroup": "Delete grouping",
    "deletePage": "Delete page",
    "deletePageConfirmDescription": "Do you really want to delete this page from the report? This action cannot be undone.",
    "editConfiguration": "Edit layout",
    "editConfigurationDescription": "How would you like to design the report?",
    "emptyStateDescription": "Create your first report now.",
    "emptyStateTitle": "No reports yet",
    "entriesRequired": {
      "finishEntries": {
        "body": "There are already entries, but they aren't rated yet. Complete at least one so you can create a report.",
        "hint": "⏱️ It only takes a few minutes.",
        "primary": "Complete entries",
        "title": "Finish your entries first."
      },
      "firstEntry": {
        "body": "First record a learning progress so you can create a report.",
        "hint": "⏱️ It only takes about 2 minutes.",
        "primary": "Start first entry",
        "title": "Start now with your first entry."
      },
      "noStudents": {
        "body": "Your class doesn't have any students yet. Add students so you can create a report.",
        "hint": "⏱️ It only takes a few minutes.",
        "primary": "Add students",
        "title": "Add students to your class first."
      },
      "noSubjects": {
        "body": "Your class doesn't have any subjects yet. Add subjects so you can create a report.",
        "hint": "⏱️ It only takes a few minutes.",
        "primary": "Add subjects",
        "title": "Add subjects to your class first."
      }
    },
    "filteredEmptyStateDescription": "No reports match the current filters.",
    "filteredEmptyStateTitle": "No matching reports",
    "finalizeDescription": "Great, we have everything we need.\nPlease review your details.",
    "finishReport": "Create report",
    "finishedReports": "Reports were created",
    "firstSemester": "1st semester",
    "generalData": {
      "allEntriesAverage": "Average of all competence entries",
      "calculationMethodLabel": "The report considers",
      "competenceAssessmentLabel": "of type",
      "description": "Please give your report a name and select the time period.",
      "endDateBeforeStartDate": "The end date cannot be before the start date.",
      "from": "From",
      "latestEntry": "Latest competence entry",
      "namePlaceholder": "Parent-teacher conference 2",
      "performanceAssessmentNotAvailable": "Not available",
      "period": "Period",
      "term": "Semester",
      "until": "up to and including"
    },
    "hideInputValues": "Fill in text fields by hand",
    "iCanDoThat": "I can already do this.",
    "lastEdited": "As of {date}",
    "level": "School level {schoolLevel}",
    "levelAndClass": "School level / class",
    "newReportGroup": "New grouping",
    "notesReport": {
      "allNotes": "All notes",
      "footerTitle": "Notes report · {section}",
      "noteCount": "{count} note | {count} notes"
    },
    "overview": {
      "access": "The following teachers have access",
      "currentState": "As of {date}"
    },
    "pdf": {
      "confirmDownloadButton": "Download",
      "confirmDownloadDescription": "Do you really want to download this report? | Do you really want to download these reports?",
      "confirmDownloadTitle": "Download report | Download reports",
      "confirmPrintButton": "Print",
      "confirmPrintDescription": "Do you really want to open this report for printing? | Do you really want to open these reports for printing?",
      "confirmPrintTitle": "Print report | Print reports",
      "generationFailed": "The PDF could not be generated. Please try again later."
    },
    "removeGroupConfirmText": "Are you sure you want to remove the grouping? The linked reports will still be available under “All reports”.",
    "rename": "Rename report",
    "report": "Report",
    "reportCount": "Reports | Report | Reports",
    "reportSubject": {
      "commentLabel": "What I'd also like to say",
      "commentPlaceholder": "Add text",
      "noCompetences": "No documented competences",
      "stateCompleted": "Subject completed",
      "stateInProgress": "Please review the subject and complete it.",
      "stateInProgressConflicts": "{count} competence ambiguous|{count} competences ambiguous"
    },
    "reports": "{count} report | {count} reports",
    "schoolYear": "School year",
    "schoolYearTerm": "School year / semester",
    "secondSemester": "2nd semester",
    "sort": {
      "createdAtAsc": "Oldest first",
      "createdAtDesc": "Newest first",
      "lastNameAsc": "Last name A-Z",
      "reportNameAsc": "Report name A-Z"
    },
    "status": {
      "completed": "Completed",
      "inProgress": "In progress"
    },
    "students": {
      "description": "Which students do you want to create the report for?"
    },
    "subjects": {
      "description": "Which competences should be included in the report?",
      "hint": "Only subjects that already have competences are shown.",
      "noSubjects": "No competence entries were found for the selected performance assessment and students.",
      "notesDescription": "Which notes should be included in the report?",
      "notesHint": "Only subjects that already have notes are shown.",
      "withoutSubject": "General",
      "withoutSubjectAbbreviation": "G"
    },
    "summary": "Summary",
    "summarySheet": {
      "nextSteps": "Next steps, support measures, agreed goals:",
      "parent": "Parent or guardian",
      "parentFeedback": "Feedback from parent or guardian:",
      "parentFeedbackAgreement": "The agreements made about the next learning steps are clear and understandable.",
      "parentFeedbackDescription": "I have been well and sufficiently informed about my child's current learning and development situation.",
      "schoolOwner": "School management",
      "signature": "Signature",
      "student": "Student",
      "teacher": "Teacher"
    },
    "title": "Reports",
    "type": {
      "description": "Which report would you like to create?",
      "notesReport": "Notes report",
      "notesReportDescription": "All notes of the period with their linked competences.",
      "select": "Select report type",
      "standard": "Standard report",
      "standardDescription": "Competences per subject with the competence flower, performance assessments or comments."
    }
  },
  "school": {
    "address": "Address",
    "all": "All schools",
    "city": "City",
    "connection": "Assigned school",
    "country": "Country",
    "create": "Create school",
    "deleteSchoolDescription": "You lead {school}. You can transfer leadership to another member or delete the school.",
    "deleteSuccess": "School deleted successfully!",
    "edit": "Edit school",
    "email": "Email",
    "import": "Import CSV",
    "importSuccess": "Schools imported successfully!",
    "isPublicOrPrivate": "Public or private",
    "location": "Location",
    "logo": {
      "errorSize": "The file is too large. Maximum 1 MB allowed.",
      "errorType": "This file type is not supported. PNG or JPG are allowed.",
      "hint": "{types} · max. {size}",
      "options": "Options",
      "proInfo": "Get your Digidoo subscription and use your own logo",
      "remove": "Remove",
      "replace": "Replace",
      "upload": "Upload logo",
      "uploading": "Uploading..."
    },
    "nameOfSchoolAdministration": "Name of school administration",
    "private": "Private",
    "public": "Public",
    "settings": "School details",
    "skzShort": "SKZ",
    "state": "State",
    "telephone": "Phone",
    "tenantCount": "Tenants",
    "title": "Title",
    "unknown": "Unknown",
    "website": "Website",
    "zipCode": "ZIP code"
  },
  "schoolGrades": {
    "better": "Improve grade (+)",
    "competenceOnly": "Competence entry only",
    "decimalDescription": "Enter half grades such as 2.5 and finer increments such as 2.25 or 2.37.",
    "decimalTitle": "Use decimal grades",
    "decrement": "Decrease grade value by 0.25 (−)",
    "disableConfirm": {
      "confirm": "Disable",
      "decimals": {
        "description": "Some entries already contain decimal grades. Do you want to disable decimal grades for new entries? Stored values and calculations remain unchanged. Grades are displayed using the current notation settings.",
        "title": "Disable decimal grades?"
      },
      "modifiers": {
        "description": "Some entries already contain plus or minus grades. Do you want to disable +/− for new entries? Stored values and calculations remain unchanged. Grades are displayed using the current notation settings.",
        "title": "Disable plus and minus?"
      }
    },
    "increment": "Increase grade value by 0.25 (+)",
    "modifier": "Change grade modifier",
    "modifiersAccessibleLabel": "Use plus and minus when grading",
    "modifiersDescription": "Adds + and − modifiers to grades in performance assessments.",
    "modifiersTitle": "Use when grading",
    "retry": "Try again",
    "saveFailed": "The grade could not be saved. Your entry has been kept.",
    "scaleLockedByRecordedGrades": "Recorded grades (including demo grades) lock the grade scale and order.",
    "scaleTitle": "Grade scale",
    "setupRequired": "A school administrator must configure a continuous 1–5 or 1–6 scale before school grades can be recorded.",
    "title": "School grades",
    "worse": "Worsen grade (−)"
  },
  "schoolSetup": {
    "finalizeDescription": "Great, we have everything we need. Please review your details.",
    "generalDataDescription": "Let's create a new school. Please set the school name and feel free to add a school motto.",
    "helpTextInviteMembers": "You can also invite your team later.",
    "invitationCount": "{count} invitations",
    "inviteMembers": "Which team members should have access?",
    "schoolName": "Institution name",
    "title": "Create school"
  },
  "schoolSubjects": {
    "abbreviation": "Abbreviation",
    "allSubjects": "All subjects",
    "competenceCount": "{ count } competence | { count } competences",
    "competenceDomainCount": "{ count } competence domain | { count } competence domains",
    "competenceOrCompetenceDomain": "Competence or competence domain",
    "confirm": {
      "confirmButtonLabel": "Import",
      "description": "You have selected subjects from the {sourceLabel}. Do you really want to import them into the {targetLabel}?",
      "descriptionDifferentSchoolType": "You have selected subjects from school level {sourceGrade} ({sourceSchoolType}). Do you really want to import them into your school's {targetLabel}?",
      "title": "Import subjects"
    },
    "confirmDelete": "Are you sure you want to delete this competence?",
    "createNew": "New subject",
    "digidooTemplate": "Digidoo template",
    "duplicateNameSuffix": " (Copy)",
    "edit": "Edit subject",
    "emptyStateCompetenceDomainDescription": "Add your first competence domain now.",
    "emptyStateCompetenceDomainTitle": "No competence domains yet",
    "emptyStateDescription": "Add your first subject now or import a template.",
    "emptyStateTitle": "No subjects yet",
    "entryCount": "{ count } entry | { count } entries",
    "export": "Export",
    "filter": "School level { schoolLevel }",
    "filteredEmptyStateCompetenceDomainDescription": "No competence domains match the current search.",
    "filteredEmptyStateCompetenceDomainTitle": "No matching competence domains",
    "filteredEmptyStateDescription": "No subjects were found for the selected school level.",
    "filteredEmptyStateTitle": "No subjects for this school level",
    "fromLibrary": "From library…",
    "fromSchoolTemplate": "From school template…",
    "fromTemplateHelpTextClass": "Missing a support focus, elective subject, etc.? Please <a class=\"underline hover:no-underline\" href=\"{ mailto }\">contact your school management.</a>",
    "fromTemplateHelpTextClassAsAdmin": "You can enable additional competence templates in the school administration.",
    "fromTemplateHelpTextMailBody": "Hi { firstNameReceiver },\n\nPlease create this competence for me:\n\nBest regards,\n{ firstNameSender }\n\n----\nPS: As a Digidoo administrator, you can find all available competence templates (e.g. support focuses, elective subjects, religions, etc.) under School administration -> Competence grid -> Add. These can be enabled for classes directly and then imported by the teacher.\n",
    "fromTemplateHelpTextMailSubject": "👉 Digidoo: Please create new competences for '{ className }'",
    "fromtTemplateHelpText": "Here you'll find the current competences from the curriculum.",
    "import": "Import…",
    "isPreselected": "Selected by default",
    "label": "Search",
    "moveToGroupAction": "Move to…",
    "newGroup": "New grouping",
    "noGroupsAvailable": "No groups available",
    "noSubjects": "No competence templates yet",
    "noSubjectsAvailable": "No subjects available",
    "placeholder": "Name or abbreviation",
    "remove": "Delete competence",
    "schoolTemplate": "School template",
    "selection": {
      "addStudents": "Add students",
      "addTeachers": "Add teachers",
      "differentStudentsDescription": "The selected subjects are relevant for different students:",
      "differentTeachersDescription": "Different teachers have access:",
      "manageStudents": "Manage Students",
      "manageTeachers": "Manage Teachers",
      "sameStudentsDescription": "The selected subjects are relevant for the following students:",
      "selectedCount": "{count} subject selected | {count} subjects selected",
      "singleStudentsDescription": "The following students are assigned to the selected subject:",
      "studentsTab": "Students",
      "subjectCount": "{count} subject | {count} subjects",
      "teacherCount": "{count} teacher | {count} teachers",
      "teachersDescription": "The following teachers have access:",
      "teachersTab": "Teachers"
    },
    "tipAdmin": "Here you can see all competences across all school levels. You can edit subjects, competence domains and individual competences, create new ones or add them from a template. These competences serve as a school-wide template and – depending on access rights – can be edited or adopted by teachers in their classes.",
    "tipTeacher": "Here you define which competences are used in class, which teachers teach each subject and which students these competences apply to.",
    "title": "Competences",
    "withoutGroup": "Without group"
  },
  "schoolYear": {
    "tip": "Here you can view the school years. They serve as the basis for all further steps in the system and are managed centrally by us."
  },
  "schoolYears": {
    "all": "All school years",
    "create": "New school year",
    "current": "Current school year",
    "edit": "Edit school year",
    "editOrCreateDialog": {
      "noStateSelected": "No state"
    },
    "emptyStateAction": "Report missing school year",
    "emptyStateDescription": "There is currently no school year configured for this school. Contact us so we can add the missing school year.",
    "emptyStateMailBody": "Hello Digidoo team,\n\nthere is a school year missing for this school.\n\nSchool: {schoolName}\nState: {state}\nSchool ID: {schoolId}\nContact person: {userName}\nEmail: {userEmail}\n\nPlease add the missing school year.\n\nThank you!",
    "emptyStateMailSubject": "Missing school year for {schoolName}",
    "emptyStateTitle": "No school year available",
    "endDate": "End",
    "endDatePlaceholder": "Choose end date",
    "namePlaceholder": "School year 2024/2025",
    "noSchoolYears": "No school years yet",
    "relevantForStates": "States",
    "schoolYearName": "School year {year}",
    "startDate": "Semester {term}",
    "startDatePlaceholder": "Choose start date",
    "status": {
      "active": "active",
      "past": "completed",
      "upcoming": "upcoming"
    },
    "term": "Semester {term}",
    "termValidation": {
      "endDateBeforeStartDate": "The end date must be after the start date",
      "firstTermBeforeSecondTerm": "The first semester must be before the second"
    },
    "view": "View school years"
  },
  "settings": {
    "class": "My class",
    "school": "School administration"
  },
  "setupChecklist": {
    "dismiss": "Don't show again",
    "dismissConfirmation": {
      "confirm": "Hide guide",
      "description": "The guide will be hidden permanently. You can, of course, still complete all the steps yourself at any time.",
      "title": "Stop showing the guide?"
    },
    "finishedBody": "We hope you enjoy using Digidoo.",
    "finishedTitle": "Yay, {firstName}!\nYou're ready to go!",
    "progress": "Set up Digidoo {completed}/{total}",
    "steps": {
      "createClass": "Create your first class",
      "createFirstEntry": "Create your first entry",
      "createDemoReport": "Create a report in the demo class",
      "demoClassTour": "Explore the demo class",
      "inviteTeam": "Invite your team",
      "setupSchool": "Set up your school"
    },
    "title": "{total} small steps\nand you're ready"
  },
  "skills": {
    "createCompetence": "New competence",
    "createCompetenceDomain": "New competence domain",
    "editSkills": "Edit competences",
    "title": "Competences"
  },
  "statistics": {
    "bar": {
      "entryCount": "{ count } entry | { count } entries"
    },
    "calculationType": {
      "allHistoricalEntries": "All entries (average)",
      "lastHistoricalEntry": "Latest entry"
    },
    "filter": {
      "allPerformanceAssessments": "All",
      "competenceFilter": {
        "title": "Only include competence checks"
      },
      "description": "Currently, the average of all entries is used for visualization.",
      "title": "Weighting"
    },
    "flower": {
      "chart": "Competence flower of {name}",
      "segment": "{name}: level {level} of {levels}",
      "segmentWithoutObservations": "{name}: no observations yet"
    },
    "noVisualsHint": "This performance assessment has no visualization of its own and is displayed via the associated competence entries.",
    "showStudent": "Go to student overview",
    "tip": "The Digidoo flower gives you a visual overview of the competence level of your class <b>{currentClass}</b>. Analyze individual subjects and competences in detail and see at a glance how all entries are distributed. Refine your analysis with targeted filters.",
    "title": "Analysis"
  },
  "student": {
    "editOrCreateDialog": {
      "add": "Add students",
      "assignAccess": "{names} gets access to these classes and groups: | {names} get access to these classes and groups:",
      "assignClassesNow": "Assign classes right away",
      "assignClassOrGroup": "Assign class or group",
      "assignments": "{name} is assigned to the following classes and groups:",
      "assignTitle": "Assign classes and groups",
      "createIntro": "Enter your students' first and last names here.",
      "edit": "Edit student",
      "moreStudents": "{count} more",
      "noAssignments": "No classes or groups assigned in this school year.",
      "removeAssignment": "Remove assignment to {name}"
    },
    "removeStudent": "Remove student",
    "removeSuccess": "Student removed!"
  },
  "studentDetails": {
    "assessmentDistribution": "Distribution",
    "assessmentRating": "Rating",
    "assessmentRatingTooltipDescription": "based on {count} entry | based on {count} entries",
    "assessmentRatingTooltipTitle": "{percentage}% achieved",
    "competenceObservation": "Competence domains",
    "competences": "Competences",
    "editPerformanceAssessmentTypes": "Edit types and weighting",
    "entries": "Entries",
    "hidePerformanceAssessment": "hide",
    "hidePerformanceAssessmentDialog": {
      "confirm": "Hide",
      "description": "You can hide this performance assessment if you do not need it right now. As soon as you create a new entry of this type, it will be {highlight}",
      "descriptionHighlight": "automatically shown again.",
      "dontShowAgain": "Don't show again",
      "title": "Hide performance assessment"
    },
    "overview": "Overview",
    "performanceAssessmentInfoDescription": "Click a performance assessment to see how the competences documented in it affect the size of the petal.",
    "performanceAssessmentInfoTitle": "Performance assessments & competences",
    "showHistory": "Show history",
    "totalOverview": "Overall overview",
    "weightingInfoAction": "Adjust now",
    "weightingInfoDescription": "Your performance assessments are weighted as follows:"
  },
  "studentTrend": {
    "allCompetences": "All competences",
    "calendarWeek": "CW{week}",
    "emptyEntries": "No competence entries yet",
    "entryCount": "{count} competence entry | {count} competence entries",
    "schoolWeek": "SW{week}",
    "title": "Development",
    "tooltipEntries": "No entries | {count} entry | {count} entries"
  },
  "students": {
    "savedBeforeAvatarUploadFailure": "Student saved. | Students saved.",
    "avatarUploadFailed": "{count} photo upload failed. | {count} photo uploads failed.",
    "addMenu": {
      "create": "New students",
      "uploadList": "Upload list…"
    },
    "addSuccess": "Student added successfully! | Students added successfully!",
    "all": "Whole class",
    "allEligible": "All {count} student | All {count} students",
    "count": "{count} student | {count} students",
    "create": "Add",
    "delete": "Delete",
    "deleteBulk": "Delete permanently",
    "deleteBulkConfirmDescription": "Please enter your first and last name or your email address to permanently delete {count} student. | Please enter your first and last name or your email address to permanently delete {count} students.",
    "deleteBulkConfirmHint": "All data linked to the selected students will be permanently deleted. This action cannot be undone.",
    "deleteBulkConfirmInputPlaceholder": "First and last name or email",
    "deleteBulkSuccess": "{count} student deleted successfully | {count} students deleted successfully",
    "deleteBulkTitle": "Delete students",
    "deleteConfirmButton": "Delete permanently",
    "deleteConfirmDescription": "Do you really want to delete {studentName} and all linked data? This action cannot be undone.\n\nPlease enter \"{name}\" to confirm the deletion.",
    "deleteConfirmInputPlaceholder": "Enter first and last name",
    "deleteConfirmTitle": "Delete student",
    "deleteSuccess": "Student deleted successfully",
    "deleteWithRelatedData": "Delete permanently",
    "editStudents": "Edit students",
    "emptyStateDescription": "Add your first student now.",
    "emptyStateTitle": "No students yet",
    "filteredEmptyStateDescription": "No students were found for the selected school year.",
    "filteredEmptyStateTitle": "No students for this school year",
    "filteredSearchEmptyStateDescription": "No students match the current search.",
    "forStudents": "For {count} student | For {count} students",
    "hasNoClass": "{name} is not assigned to a class.",
    "import": {
      "addAsNew": "Add a new student",
      "allAtSchool": "The name is already at the school | All {count} names are already at the school",
      "assignNames": "Match names",
      "cleared": "All sorted.",
      "clearNames": "No name is clear | {count} of {total} names is clear | {count} of {total} names are clear",
      "dropFile": "Drop a photo or file here or",
      "emptyFile": "The file is empty. Choose a file containing student names.",
      "failed": "The import failed. Please upload the list again to start over.",
      "intro": "Digidoo takes only first and last names from your list. You check them before anything is saved.",
      "knownAtSchool": "{count} name is already at the school. | {count} names are already at the school.",
      "namesakesAfterAdding": "Then {count} students will have this name.",
      "nothingFound": "No names were found in the list.",
      "nothingToAdd": "There is nothing to add.",
      "otherList": "Upload another list",
      "pastedText": "Pasted text",
      "questionNumber": "Question {number} of {count}",
      "questionsIntro": "For one name, several students at your school have the same name. Tell us who is meant. | For {count} names, several students at your school have the same name. Tell us who is meant.",
      "readFailed": "The list could not be read. Try a sharper photo or upload the list as CSV.",
      "reading": "Reading your list…",
      "review": "Check the name before you add it. | Check the names before you add them.",
      "reviewOthers": "Check the other name before you add it. | Check the others before you add them.",
      "supportedFormats": "Photo, scan, PDF or CSV",
      "textTooLong": "The file is too long. Split the list and upload the parts one by one.",
      "title": "Upload list",
      "whoIsMeant": "Which {name} do you mean?"
    },
    "none": "Without students",
    "searchPlaceholder": "First or last name",
    "select": "Select students",
    "selection": {
      "selectedCount": "{count} student selected | {count} students selected"
    },
    "selectionSearchPlaceholder": "Search students …",
    "singleStudentTip": "Here you get a comprehensive insight into the learning progress of <b>{student}</b>: see all competences of the enrolled subjects, the timeline of entries, and a detailed analysis with the Digidoo flower – down to competence level and with helpful filters.",
    "tipAdmin": "Here you can find all students of your <b>{school}</b>. You can view and edit their data and use filters and search to find specific people.",
    "tipAll": "Here you can see the timeline of all entries of your class <b>{currentClass}</b> at a glance. Get a precise overview and filter by subject.",
    "tipSettings": "Here you can see all students of your class <b>{currentClass}</b>. Depending on your permissions, you can manage their data or add new students to the class.",
    "wholeClassWithName": "Class {name}"
  },
  "teacher": {
    "copyInvitationLink": "Copy link",
    "edit": "Edit member",
    "invitationLinkCopied": "Invitation link copied to clipboard",
    "invitationSuccess": "{ email } has been invited",
    "invitationsSkippedDeactivated": "These accounts are deactivated and were skipped: { emails }",
    "invitationsSuccess": "Invitation successfully sent to { count } person | Invitations successfully sent to { count } people",
    "invite": "Invite",
    "externalPersonsHint": "External people can also be part of your team: invite people outside your school - e.g. psychologists, speech therapists, or therapists. They only see the students and competences you select.",
    "inviteMoreMembers": "Invite more people to your team.",
    "remove": "Delete team member",
    "removeConfirmText": "Are you sure you want to remove {userName} from your school?",
    "resend": "Resend invitation",
    "teacherAccess": "{firstName} has access:",
    "team": "Team",
    "tip": "Here you can invite and manage your entire <b>{schoolName}</b> team. Assign roles such as member, admin, or external person, and keep track of class access and the current invitation status.",
    "unlink": "Remove team member"
  },
  "templateSet": {
    "countryWide": "Entire country (no state)",
    "importDialog": {
      "chooseSchoolType": "Choose school type",
      "hint": "Missing a state or do you have ideas or feedback?",
      "missingTemplate": {
        "bodyPrefix": "Simply ",
        "bodySuffix": " and Digidoo will detect everything automatically.",
        "dialog": {
          "action": "Write to Digidoo",
          "body": "Send us your templates, grids or documents by email. We read the subjects and competences and add them to our library. As soon as they are available, we will get back to you.",
          "bodyUnavailableRegion": "Competence templates are not available for {region} yet. Send us your templates, grids or documents by email. We will add them to our library and get back to you as soon as they are available.",
          "contextMissing": "Not selected",
          "mailBody": "Hello Digidoo team,\n\nI would like to send you templates, grids or documents for the competence library.\n\nSchool type: {schoolType}\nCountry: {country}\nState: {state}\n\nPlease get back to me if you need any further information.\n\nThank you!",
          "mailSubject": "Templates for the Digidoo competence library",
          "tip": "Please only email grids and templates — no student data.",
          "title": "Send us your templates"
        },
        "formats": "Upload PDF, Word, Excel or image",
        "title": "No template found?",
        "unavailable": "No templates available yet",
        "uploadAction": "upload a file"
      },
      "noSchoolTypes": "No school types available",
      "nothingSelected": "Please choose a region and school type",
      "title": "Competence library"
    },
    "isCurrent": "Current",
    "isDefault": "Default",
    "pdf": {
      "allGroups": "All subject groups",
      "confirmDownloadButton": "Download",
      "confirmDownloadDescription": "Do you want to download the competence template as a PDF?",
      "confirmDownloadTitle": "Download template",
      "exportButton": "Create",
      "exportDialogTitle": "Export PDF template",
      "generationFailed": "PDF generation failed. Please try again.",
      "noVisualSelected": "Please select a performance visual first.",
      "subjectGroups": "Subject groups"
    },
    "remove": "Delete template",
    "removeConfirmText": "Are you sure you want to delete this template?",
    "title": "Competence templates",
    "transfer": {
      "dropFile": "Drop a ZIP file here or",
      "exportAction": "Export competence grid",
      "exportDescription": "Download your school’s complete competence grid as a ZIP file? Student data, assessments and entries are excluded.",
      "exportError": "The download failed. Please try again.",
      "exportSuccess": "Download successful",
      "exportTitle": "Export competence grid",
      "importAction": "Import competence grid",
      "importDescription": "The subjects and competences from the file will be added to your competence grid. Are you sure you want to continue?",
      "importError": "The import failed. No changes were made. Please check the file and try again.",
      "importPending": "Importing competence grid …",
      "importReplaceDescription": "The subjects and competences from the file will be added to your competence grid and your existing template will be replaced.\n\nPlease enter your first and last name or your email address to confirm the import.",
      "importReplaceHint": "This action cannot be undone.",
      "importReplaceSettingsDescription": "The subjects and competences from the file will be added to your competence grid, your existing template will be replaced and all subject settings will be deleted.\n\nPlease enter your first and last name or your email address to confirm the import.",
      "importSuccess": "Competence grid imported successfully",
      "importTitle": "Import competence grid",
      "invalidFile": "This file is not a valid Digidoo export or is damaged. Please choose an unchanged ZIP file exported from Digidoo.",
      "levelNotInFile": "Not included in the file",
      "noMatchingLevels": "The file contains no subjects for your school’s active school levels.",
      "previewHint": "Contains {schoolLevels} school levels · {importedSchoolLevels} will be imported. Switch the school level above to see everything.",
      "supportedFormat": "Only .zip files from “Export competence grid”",
      "uploadDescription": "Upload the ZIP file from a Digidoo export — in the next step you will see what will be imported.",
      "uploadHint": "Only school levels, subjects and competences are imported — no student data."
    },
    "unknownState": "Unknown state (ID: {stateId})",
    "upload": {
      "dropFile": "Drop a JSON file here or",
      "hiddenSchoolLevels": "The chosen school type doesn't have school levels {levels} from the file. Their subjects won't be shown.",
      "invalidFile": "This file is not a valid competence template. Expected a JSON file with subject groups, subjects, domains and competences.",
      "label": "Display name",
      "noMatchingSchoolLevels": "The file only has subjects for school levels {fileLevels}, but the chosen school type has school levels {schoolTypeLevels}. Please choose a matching school type.",
      "pending": "Importing competence template …",
      "requiredField": "Required",
      "schoolLevelsMismatch": "The file has no subjects for the school levels of the chosen school type.",
      "success": "Competence template imported successfully",
      "supportedFormat": "Only .json files with subject groups, subjects, domains and competences",
      "title": "Import competence template",
      "validating": "Checking file …",
      "versionFormat": "Enter the version as a year, e.g. 2026, or with a month, e.g. 2026-10."
    },
    "version": "Version"
  },
  "tenants": {
    "activate": "Enable",
    "activateTenant": "Reactivate school & do not delete",
    "add": "Add school",
    "addStaff": "Add staff",
    "address": "Address",
    "billing": {
      "billedByTenant": "Active",
      "billedExternally": "Disabled",
      "mode": "Billing mode",
      "perUser": "Per user"
    },
    "changeSchoolTypeConfirm": {
      "confirmButtonLabel": "Change school type",
      "description": "The school type will change from {currentName} to {targetName}.",
      "hint": "Existing school levels, classes, subjects, and assessments remain unchanged. Future curriculum and subject templates will follow the new school type.",
      "title": "Change school type?"
    },
    "city": "City",
    "classes": "Classes",
    "create": "Create school",
    "currentStaffDescription": "These people currently have access",
    "deactivate": "Disable",
    "deactivateConfirm": {
      "description": "Should school {school} be deactivated? This school will no longer be accessible to teachers.",
      "title": "Deactivate school"
    },
    "deactivateTenant": "Deactivate school & delete in 14 days",
    "deleteImmediately": "Delete immediately",
    "deleteImmediatelyConfirm": {
      "description": "This permanently deletes school {school} now. This cannot be undone.",
      "hint": "The same deletion path as the automatic cleanup will run immediately.",
      "inputPlaceholder": "School name",
      "title": "Delete school immediately"
    },
    "detail": {
      "billingCustomerIdCopied": "Billing ID copied",
      "tabs": {
        "members": "Members",
        "overview": "Overview",
        "referral": "Referrals"
      }
    },
    "edit": "Edit school",
    "isDisabled": "Disabled",
    "locationAndSchoolType": "Location and school type",
    "maintenanceRole": "Support",
    "manageClassAccess": "Manage class access",
    "members": {
      "emptyDescription": "Nobody belongs to this school yet.",
      "emptyTitle": "No members",
      "loadError": "The members could not be loaded.",
      "loading": "Loading members…"
    },
    "noSchoolOption": "No assigned school",
    "referral": {
      "balanceResetAt": "Balance reset to 0% · {date}",
      "discountGranted": "Credit from support",
      "discountProgress": "{percent}% of {max}% discount collected.",
      "discountReceivedAt": "Discount received · {date}",
      "discountRedeemed": "Discount redeemed",
      "emptyDescription": "Sign-ups through this school's link, their subscriptions and credits appear here.",
      "emptyTitle": "No referrals yet",
      "grant": {
        "button": "Credit discount",
        "description": "The discount is added to {school}'s balance and applies to its next payment.",
        "note": "Reason (optional)",
        "percent": "Discount",
        "percentOption": "{percent}%",
        "submit": "Credit",
        "success": "Discount credited.",
        "title": "Credit discount"
      },
      "grantedByAt": "By {name} · {date}",
      "history": "History",
      "loading": "Loading referrals…",
      "maximumAlreadyReachedAt": "Maximum already reached · {date}",
      "maximumReached": "Maximum reached",
      "percentGained": "+{percent}%",
      "percentLost": "−{percent}%",
      "referralAcceptedAt": "Referral accepted · {date}",
      "startedAt": "Started · {date}",
      "subscribedAt": "Subscribed · {date}",
      "support": "Support",
      "viaLink": "via link"
    },
    "remove": "Delete school",
    "removeConfirmText": "Are you sure you want to delete the school \"{name}\"?",
    "restoreConfirm": {
      "confirmButtonLabel": "Restore",
      "description": "School {school} will be reactivated and will no longer be automatically deleted. Its owner’s account will also be reactivated if it is deactivated.",
      "title": "Restore school?"
    },
    "staff": "Staff",
    "students": "Students",
    "subscription": {
      "emptyDescription": "No subscription is on file for this school.",
      "emptyTitle": "No subscription",
      "endedAt": "Ended on",
      "endsAt": "Ends on",
      "loadError": "The subscription could not be loaded.",
      "loading": "Loading subscription…",
      "plan": "Plan",
      "renewsAt": "Renews on",
      "seats": "Seats",
      "startedAt": "Start date"
    },
    "templateSetSource": {
      "bmukk": "BMUKK",
      "custom": "Custom",
      "digidoo": "Digidoo",
      "official": "Official"
    },
    "title": "Tenants",
    "willBeDeletedAt": "Will be deleted at",
    "zipCode": "ZIP code"
  },
  "terms": {
    "title": "Terms and Conditions for Digidoo"
  },
  "tfaForSchool": {
    "activateButton": "Enable now",
    "activateSuccessSchoolToast": "Two-factor authentication enabled",
    "deactivateSuccessSchoolToast": "Two-factor authentication disabled",
    "description": "Decide whether all team members of your organization must also sign in with two-factor authentication. This keeps all accounts consistently and optimally protected.",
    "descriptionBottom": "With two-factor authentication (2FA), you secure your Digidoo account even better – either via app or email. <span class='font-semibold'>This keeps your account optimally protected.</span>",
    "descriptionTitle": "Two-factor authentication for the whole team",
    "descriptionTop": "To better protect the accounts at your school, two-factor authentication (2FA) has been enabled for the whole team.",
    "dialogDescription": "Your team will be informed automatically and has <span class='font-semibold'>7 days</span> to complete the setup.",
    "dialogTitle": "Enable two-factor authentication for your team",
    "laterButton": "Enable later",
    "title": "Enable two-factor authentication now",
    "tooltipProfileLabel": "your profile",
    "tooltipText": "First enable 2FA in {profile} before you can turn it on for your school."
  },
  "timeline": {
    "activeSupportMeasureCount": "{count} active support measure | {count} active support measures",
    "activeSupportMeasures": "Active support measures",
    "calendarWeek": "CW {week}",
    "filterEntries": "Filter entries",
    "incompleteItems": "Open entries",
    "lastWeek": "Last week",
    "moreCompetences": "and {count} more",
    "notes": "Note",
    "openEntryCount": "{count} open entry | {count} open entries",
    "schoolWeek": "SW {week}",
    "showLessCompetences": "Show less",
    "thisWeek": "This week"
  },
  "transferOwnership": {
    "infoTitle": "{invitedBy} has invited you to take over ownership of the school \"{schoolName}\".",
    "invitationSuccess": "Ownership transfer request sent to { email }",
    "pendingRequest": "Ownership request pending",
    "pendingRequestWithDate": "Ownership request pending (valid until {date})",
    "receiveDescription": "If you take over ownership, you'll be responsible for managing and billing the subscription going forward.\n\nThe previous owner will remain an admin and keep access to all features.",
    "receiveTitle": "Take over ownership",
    "receivedInvitation": "I've received an invitation to take over ownership.",
    "sendDescription": "If you transfer ownership, the new person will be responsible for managing and billing the subscription going forward.\n\nDon't worry - you'll remain an admin and can keep using everything as usual.",
    "title": "Transfer ownership"
  },
  "twoFactorAuth": {
    "activatedSuccess": "Two-factor authentication enabled successfully",
    "dialog": {
      "mailStep": {
        "subtitle": "To enable two-factor authentication, please confirm that you'd like to receive security codes by email in the future."
      },
      "modeSelection": {
        "appMode": {
          "description": "I want to generate the code with my authenticator app, such as Google Authenticator or 1Password.",
          "title": "Authenticator app"
        },
        "description": "Which type of two-factor authentication would you like to use?",
        "emailMode": {
          "description": "I want to receive the code via email",
          "title": "Via email"
        }
      },
      "title": "Two-factor authentication",
      "totpStep": {
        "description": "To verify, please enter the code now shown in your authenticator app.",
        "subtitle": "To enable two-factor authentication, <span class='font-semibold'>scan the QR code</span> with your authenticator app and then enter the code it shows below."
      }
    },
    "helpText": "{findOutMore} about security and two-factor authentication in Digidoo."
  },
  "user": {
    "activateConfirm": {
      "description": "Activating the user will send a confirmation email. Continue?",
      "title": "Activate user?"
    },
    "deactivateConfirm": {
      "description": "If this user is deactivated, they can no longer log in and will be deleted automatically in {days} days. Continue?",
      "ownerDescription": "This user is the owner of the school {schools}. Deactivating the user will also deactivate the school, and it will be deleted in 14 days. | This user is the owner of the schools {schools}. Deactivating the user will also deactivate the schools, and they will be deleted in 14 days.",
      "title": "Deactivate user"
    },
    "deleteImmediatelyConfirm": {
      "description": "This permanently deletes the user now. If this user owns schools scheduled for deletion, those schools will also be deleted immediately. This cannot be undone.",
      "hint": "The same deletion path as the automatic cleanup will run immediately.",
      "inputPlaceholder": "Name or email",
      "ownerDescription": "This user owns school {schools}. Owned schools will also be deleted immediately. | This user owns schools {schools}. Owned schools will also be deleted immediately.",
      "title": "Delete user immediately"
    },
    "detail": {
      "acquisitionSelfReported": "In their own words",
      "acquisitionSource": "Acquisition source",
      "acquisitionSourceOther": "Source (free text)",
      "attribution": {
        "capturedAt": "First visit",
        "clickIdKeys": "Ad click on first visit",
        "clickIds": "Ad clicks",
        "description": "First visit and latest ad clicks, recorded at sign-up.",
        "empty": "There's no data for this account yet, for example because it was created before we started recording it.",
        "landingPage": "Landing page",
        "platforms": {
          "googleAds": "Google Ads",
          "meta": "Meta",
          "microsoftAds": "Microsoft Ads",
          "tiktokAds": "TikTok Ads"
        },
        "referrer": "Came from",
        "title": "The way to Digidoo",
        "utmCampaign": "Campaign (utm_campaign)",
        "utmContent": "Ad (utm_content)",
        "utmMedium": "Channel (utm_medium)",
        "utmSource": "Source (utm_source)",
        "utmTerm": "Keyword / audience (utm_term)"
      },
      "avatarSecurityHint": "Uploaded profile pictures are not loaded for security reasons.",
      "copyEmail": "Copy email address",
      "emailChanges": {
        "newEmail": "New email address",
        "oldEmail": "Previous email address",
        "title": "Email address changes"
      },
      "emailCopied": "Email address copied to clipboard",
      "loginProviders": "Login providers",
      "openInTenants": "Open in Tenants",
      "openInUsers": "Open in Users",
      "schools": "Schools",
      "sendWeeklyReport": "Send weekly report",
      "sendWeeklyReportSuccess": "Weekly report sent successfully",
      "tabs": {
        "acquisition": "Origin",
        "emails": "Emails",
        "profile": "Profile"
      }
    },
    "filteredEmptyStateDescription": "Invite a team member now.",
    "filteredEmptyStateTitle": "No team members found for the current search",
    "resetTfaConfirm": {
      "description": "This deactivates the user's two-factor authentication and removes their registered authenticator app. Afterwards the user can log in with their password only and set two-factor authentication up again.",
      "title": "Reset two-factor authentication?"
    },
    "restoreConfirm": {
      "confirmButtonLabel": "Restore",
      "description": "The user account will be reactivated and will no longer be automatically deleted.",
      "hint": "This user’s deactivated schools remain scheduled for deletion. Restore the schools you want to keep separately under “Schools”.",
      "title": "Restore user?"
    },
    "table": {
      "access": "Access",
      "actions": {
        "activateUser": "Activate & do not delete",
        "approveUser": "Activate",
        "deactivateUser": "Deactivate & delete in 14 days",
        "deleteImmediately": "Delete immediately",
        "resetTfa": "Reset 2FA",
        "revokeApprovalUser": "Deactivate",
        "willBeDeletedAt": "Will be deleted at"
      },
      "active": "active",
      "deleteInvitation": "Delete invitation",
      "email": "Email address",
      "firstName": "First name",
      "invitationExpired": "Invitation expired.",
      "invitationPending": "Invitation pending",
      "invitationPendingShort": "invited",
      "invitationPendingWithDate": "Invitation pending (valid until {date})",
      "isApproved": "Activated",
      "isDeactivated": "Deactivated",
      "isSetupCompleted": "Onboarding completed",
      "lastName": "Last name",
      "ownershipInvitationExpired": "Ownership request expired",
      "resendInvitation": "Resend invitation"
    },
    "title": "Users"
  },
  "userRole": {
    "admin": "Admin",
    "external": "External person",
    "owner": "Owner",
    "user": "Member"
  },
  "userRoleDescription": {
    "admin": "Manage the team, classes, and access rights.",
    "external": "Have access to selected students and competences.",
    "owner": "As the owner, you manage the Digidoo school account. The role is assigned automatically to the person who creates the account and can later be transferred to another person at any time.",
    "user": "Have access to their assigned classes."
  },
  "userRoleStatus": {
    "active": "Active",
    "disabled": "Deactivated",
    "invitationDeclined": "Invitation declined",
    "invitationPending": "Invitation pending"
  },
  "userStatus": {
    "deactivatedTitle": "This user is deactivated and will be\ndeleted automatically in {count} day. | This user is deactivated and will be\ndeleted automatically in {count} days."
  },
  "userwidget": {
    "logout": "Log out",
    "profile": "My account"
  },
  "waitingRoom": {
    "classesToFinalizeMessage": "You've been invited to join the class { className }.",
    "classesToFinalizeMessageCreator": "You've created the class { className } and can now set it up.",
    "noClassDescription": "You haven't been assigned to a class yet. We'll let you know as soon as you can get started.",
    "specificClassWaitingRoom": "The class { className } hasn't been set up yet. You can finish setting it up now.",
    "subtitle": "Welcome to {schoolName}",
    "title": "Hi {firstName},"
  },
  "website": {
    "baseUrl": "https://www.digidoo.com",
    "pricingUrl": "https://www.digidoo.com/preise"
  },
  "schoolTypeConfiguration": {
    "title": "School type configuration",
    "labelMode": "Level numbering",
    "labelModeAdjusted": "Relative",
    "labelModeRaw": "Absolute",
    "labelModeInfo": "Sets how this school type's levels are numbered for teachers and reports. Absolute keeps the real level number — e.g. a Gymnasium covering levels 7–12 is shown as 7–12. Relative re-numbers them from 1 — shown as 1–6."
  },
  "masterData": {
    "title": "Master data",
    "countries": "Countries",
    "states": "States",
    "schoolTypes": "School types",
    "isoCode": "ISO code",
    "isSupported": "Supported",
    "contentLanguages": "Content languages",
    "contentLanguagesPlaceholder": "Select languages",
    "primaryLanguage": "Primary language",
    "abbreviation": "Abbreviation",
    "color": "Color",
    "symbol": "Symbol",
    "parentState": "Parent state",
    "noParent": "None",
    "translations": "Translations",
    "deleteCountryConfirm": "Are you sure you want to delete the country \"{name}\"?",
    "deleteStateConfirm": "Are you sure you want to delete the state \"{name}\"?",
    "deleteSchoolTypeConfirm": "Are you sure you want to delete the school type \"{name}\"?"
  },
  "competenceAssessmentLevelTextCatalog": {
    "highly-achieved": {
      "description": "I work independently and can apply my knowledge and skills confidently on my own. I have achieved the learning objective to a high degree.",
      "title": "I can do this really well."
    },
    "mostly-achieved": {
      "description": "I can meet most of the requirements independently. I have largely achieved the learning objective.",
      "title": "I can already do this quite well."
    },
    "not-yet-achieved": {
      "description": "I have not yet achieved the learning objective.",
      "title": "I still need to practise this."
    },
    "partially-achieved": {
      "description": "With support, I can meet the requirements. I have partially achieved the learning objective.",
      "title": "I can already do this a little."
    }
  },
  "gradeScaleLevelCatalog": {
    "adequate": "Adequate",
    "deficient": "Deficient",
    "good": "Good",
    "insufficient": "Insufficient",
    "not-sufficient": "Not sufficient",
    "satisfactory": "Satisfactory",
    "sufficient": "Sufficient",
    "very-good": "Very good",
    "very-weak": "Very weak",
    "weak": "Weak"
  },
  "performanceAssessmentCatalog": {
    "cooperation": "Participation",
    "homework": "Homework",
    "oral-exam": "Oral exam",
    "oral-exercise": "Oral exercise",
    "test": "Test",
    "written-exam": "Written exam"
  },
  "visualCatalog": {
    "colors": "Colors",
    "plants": "Plants",
    "plus-wave-minus": "Plus – Wave – Minus",
    "grade-scale": "Grades",
    "smileys": "Smileys",
    "thumbs": "Thumbs",
    "check-mark": "Check mark"
  },
  "supportMeasureEntry": {
    "dialogTitle": "Support measure",
    "notes": "Note for support measure",
    "documentation": "Documentation",
    "linkedApps": "Linked apps",
    "nextStudent": "Next student",
    "previousStudent": "Previous student",
    "openStudentList": "Open student list",
    "readdStudent": "Add again",
    "removeAndDeleteEntries": "Remove and delete all entries",
    "inactiveStudentsShow": "and {count} inactive student | and {count} inactive students",
    "inactiveStudentsHide": "Hide inactive students",
    "removeStudentConfirm": {
      "title": "Remove student?",
      "description": "Do you really want to remove {name} from this support measure? All related entries will be permanently deleted.",
      "confirm": "Remove and delete entries"
    },
    "removeLastStudentConfirm": {
      "title": "Remove last student?",
      "description": "{name} is the last student of this support measure. Do you want to delete the entire support measure or only remove the student?",
      "deleteEntry": "Delete support measure",
      "keepEntry": "Only remove student"
    },
    "supportPeriod": "Support period",
    "newEntry": "New support measure",
    "metadataDescription": "Edit the subject and annotation of the support measure.",
    "upsellTitle": "Support measures with Digidoo",
    "upsellDescription": "Record support goals and progress without limits.",
    "upsellAriaLabel": "Open subscription plans for support measures",
    "competencesQuestion": "Do you want to add competences to this support measure?",
    "competencesHelpText": "You can also create the support measure without competences.",
    "studentsDescription": "Choose the students for the support measure.",
    "materials": {
      "allApps": "All apps",
      "appChip": "App",
      "commandOpen": "Apps…",
      "question": "Do you want to add supporting material such as external apps or websites?",
      "searchPlaceholder": "App or material",
      "helpText": "You can also continue without external material.",
      "previouslyUsed": "Already used",
      "selected": "Selected",
      "recommended": "Recommended",
      "recentlyUsed": "Recently used",
      "addMaterial": "Add material",
      "otherSchoolLevel": "Other school level",
      "empty": "No matching material found.",
      "addAsOwnApp": "Add as your own app",
      "info": "Info",
      "visitWebsite": "Visit website",
      "cost": "Cost",
      "free": "Free",
      "paid": "Paid",
      "sidebarTitle": "External material",
      "add": "Add material",
      "none": "No material linked"
    },
    "editEntry": "Edit support measure",
    "deleteEntryTitle": "Delete support measure?",
    "deleteEntryDescription": "This support measure and its protocol will be permanently deleted.",
    "noGoalAndMeasuresCompleted": "No goals & measures added.",
    "protocol": "Protocol",
    "protocolEmptyHint": "After each session, briefly note what you worked on.",
    "protocolPlaceholder": "What was practiced?",
    "protocolRequiredAction": {
      "competenceRating": "Rate the selected competence.",
      "students": "Select at least one student.",
      "text": "Add a protocol entry.",
      "textTooLong": "The protocol entry is too long. Please shorten it."
    },
    "addProtocolEntry": "Add protocol entry",
    "complete": "Complete",
    "completeDialogTitle": "Complete support measure",
    "completeDialogDescription": "The measure will be completed for all {count} students. After that you can no longer add entries.",
    "completionNoteLabel": "Closing note (optional)",
    "completionNotePlaceholder": "e.g. which material helped or what you would do again",
    "completionRatingLabel": "Was the support measure successful?",
    "ratingNegative": "Not successful",
    "ratingNeutral": "Neutral",
    "ratingPositive": "Successful",
    "cancelTitle": "Discard support measure?",
    "cancelDescription": "Your entries will not be saved.",
    "activityCount": {
      "competences": "{count} competence | {count} competences"
    },
    "activityVerb": {
      "added": "added",
      "removed": "removed",
      "entriesRemoved": "permanently removed",
      "linked": "linked",
      "unlinked": "unlinked"
    },
    "deleteProtocolTitle": "Delete protocol entry?",
    "deleteProtocolDescription": "This protocol entry will be permanently deleted.",
    "unknownAuthor": "Unknown",
    "rating": {
      "question": "Was this support measure helpful?",
      "helpful": "Helpful",
      "notHelpful": "Not helpful"
    },
    "report": {
      "competenceDomain": "Competence domain",
      "completedByOn": "{name} on {date}",
      "completionNote": "Closing note",
      "confirmDescription": "Your support report is ready. Do you want to download it now? | Your support reports are ready. Do you want to download them now?",
      "confirmTitle": "Download support report | Download support reports",
      "content": "Content",
      "contentHint": "Support planning and protocol are always included.",
      "coverSheet": "Cover page",
      "coverSheetPlant": "Plant",
      "coverSheetSimple": "Simple",
      "createAll": "Create all support reports",
      "createReport": "Create support report",
      "designQuestion": "How would you like to design the report?",
      "documentTitle": "Support plan",
      "download": "Download",
      "firstAssessment": "First assessment in the support period",
      "footerTitle": "Support plan · {subject}",
      "generationFailed": "The support report could not be created. Please try again later.",
      "goalsAndMeasures": "Support goal & planned measures",
      "latestAssessment": "Current assessment",
      "materials": "Apps & material",
      "observation": "Observation",
      "parents": "Parents",
      "planningTitle": "Support planning & development",
      "showCompetenceDevelopment": "Show competence development",
      "showCompletionNote": "Show closing note",
      "showMaterials": "Show apps & material",
      "signatures": "Signatures",
      "since": "since {date}"
    }
  },
  "avatar": {
    "uploadPicture": "Upload own image..."
  }
}
